{
  "user": {
    "form": {
      "addTitle": "Cipta Pengguna",
      "editTitle": "Sunting Pengguna",
      "fields": {
        "username": "Nama Pengguna",
        "email": "E-mel",
        "fullName": "Nama Penuh",
        "password": "Kata Laluan",
        "confirmPassword": "Sahkan Kata Laluan",
        "facility": "Fasiliti",
        "roles": "Peranan",
        "active": "Aktif",
        "allFacilities": "Semua fasiliti (seluruh sistem kesihatan)",
        "globalAccessAck": "Saya faham bahawa ini memberikan akses kepada semua fasiliti",
        "departments": "Jabatan",
        "primaryDepartment": "Utama",
        "roleFacility": "Fasiliti untuk {{role}}",
        "grantEffective": "Effective date for {{role}} (blank = today)",
        "grantExpiration": "Expiration date for {{role}} (blank = permanent)",
        "grantProvenance": "Granted by {{name}}",
        "grantProvenanceDate": "Granted by {{name}} · {{date}}",
        "addFacilityToRole": "+ fasiliti lain",
        "removeFacilityFromRole": "buang satu",
        "otherRoles": "Lain-lain"
      },
      "errors": {
        "usernameMin": "Nama pengguna mestilah sekurang-kurangnya {{min}} aksara",
        "emailInvalid": "Alamat e-mel tidak sah",
        "passwordMin": "Kata laluan mestilah sekurang-kurangnya {{min}} aksara",
        "confirmPasswordRequired": "Sila sahkan kata laluan",
        "passwordMismatch": "Kata laluan tidak sepadan",
        "rolesRequired": "Sekurang-kurangnya satu peranan diperlukan",
        "grantPeriodInvalid": "The grant ends before it starts",
        "globalAccessAckRequired": "Sahkan pemberian akses seluruh sistem kesihatan sebelum menyimpan."
      },
      "submit": {
        "create": "Cipta Pengguna",
        "update": "Kemas Kini Pengguna"
      },
      "cancel": "Batal",
      "toast": {
        "createdSuccess": "Pengguna berjaya dicipta",
        "updatedSuccess": "Pengguna berjaya dikemas kini",
        "saveError": "Gagal menyimpan pengguna",
        "departmentsSaveError": "Pengguna disimpan, tetapi penetapan jabatan gagal. Sunting pengguna untuk cuba lagi."
      },
      "globalAccessWarning": "Ini memberikan akses kepada pesakit di SEMUA fasiliti, bukan sekadar jangkauan panggilan. Gunakan hanya untuk kakitangan yang benar-benar meliputi seluruh sistem kesihatan, seperti petugas bertugas.",
      "departmentsHint": "Tempat akaun ini bekerja. Ini konteks dan atribusi sahaja — ia tidak memberi akses kepada mana-mana pesakit.",
      "noDepartments": "Tiada jabatan dikonfigurasikan lagi."
    },
    "list": {
      "title": "Pengurusan Pengguna",
      "subtitle": "Urus pengguna sistem, peranan, dan akses",
      "columns": {
        "username": "Nama Pengguna",
        "fullName": "Nama Penuh",
        "email": "E-mel",
        "roles": "Peranan",
        "facility": "Kemudahan",
        "status": "Status",
        "lastLogin": "Log Masuk Terakhir",
        "actions": "Tindakan",
        "signIn": "Sign-in"
      },
      "filter": {
        "search": "Cari pengguna...",
        "allRoles": "Semua Peranan",
        "allFacilities": "Semua Kemudahan",
        "allStatus": "Semua Status",
        "active": "Aktif",
        "inactive": "Tidak Aktif"
      },
      "actions": {
        "new": "Cipta Pengguna",
        "editTitle": "Edit pengguna",
        "resetPasswordTitle": "Set semula kata laluan",
        "activate": "Aktifkan",
        "deactivate": "Nyahaktifkan",
        "activateAria": "Aktifkan pengguna",
        "deactivateAria": "Nyahaktifkan pengguna"
      },
      "lastLoginNever": "Tidak Pernah",
      "empty": "Tiada pengguna sepadan dengan penapis anda",
      "pagination": {
        "summary": "Menunjukkan {{from}}-{{to}} daripada {{total}}"
      },
      "toast": {
        "activated": "Pengguna {{username}} diaktifkan",
        "deactivated": "Pengguna {{username}} dinyahaktifkan",
        "passwordHasBeenReset": "Password for {{username}} has been reset",
        "statusFailed": "Could not update the status of {{username}}",
        "passwordFailed": "Could not reset the password"
      },
      "allFacilities": "Semua fasiliti",
      "deactivateConfirm": {
        "title": "Deactivate {{username}}?",
        "description": "New logins and token refreshes for {{username}} will be refused. Their roles are kept, so reactivating restores access.",
        "confirm": "Deactivate"
      },
      "resetPassword": {
        "title": "Reset password for {{username}}",
        "description": "Set a new password. It must be at least 12 characters with upper- and lowercase letters, a digit and a special character.",
        "label": "New password",
        "confirm": "Reset password"
      },
      "signIn": {
        "local": "Local",
        "sso": "SSO",
        "ldap": "Directory"
      }
    },
    "status": {
      "active": "Aktif",
      "inactive": "Tidak Aktif",
      "locked": "Dikunci",
      "pendingActivation": "Menunggu Pengaktifan"
    },
    "mfaStatus": {
      "enrolled": "Didaftarkan",
      "notEnrolled": "Tidak Didaftarkan",
      "exempt": "Dikecualikan"
    }
  },
  "role": {
    "form": {
      "addTitle": "Cipta Peranan",
      "editTitle": "Sunting Peranan",
      "fields": {
        "name": "Nama Peranan",
        "code": "Kod Peranan",
        "description": "Penerangan",
        "category": "Kategori",
        "parentRole": "Peranan Induk (mewarisi kebenaran)"
      },
      "options": {
        "none": "Tiada"
      },
      "errors": {
        "nameRequired": "Nama peranan diperlukan",
        "codeRequired": "Kod peranan diperlukan"
      },
      "submit": {
        "create": "Cipta Peranan",
        "update": "Kemas Kini Peranan"
      },
      "cancel": "Batal",
      "toast": {
        "createdSuccess": "Peranan berjaya dicipta",
        "updatedSuccess": "Peranan berjaya dikemas kini",
        "saveError": "Gagal menyimpan peranan"
      }
    },
    
    "status": {
      "active": "Aktif",
      "inactive": "Tidak Aktif"
    },
    "source": {
      "own": "Sendiri",
      "inherited": "Diwarisi",
      "category": "Kategori"
    },
    "permissions": {
      "ownTitle": "Sunting Kebenaran",
      "deniedTitle": "Sunting Kebenaran yang Ditolak",
      "ownSubtitle": "{{granted}} daripada {{total}} diberikan. Kebenaran warisan dan lalai kategori ditunjukkan dalam Matriks Akses; halaman ini hanya mengurus pemberian peranan itu sendiri.",
      "deniedSubtitle": "Kebenaran yang ditolak mengatasi pemberian daripada kebenaran peranan itu sendiri, peranan induknya, dan lalai kategorinya. Tandakan kebenaran untuk menolaknya secara eksplisit bagi peranan ini.",
      "invalidRoleId": "ID peranan tidak sah.",
      "save": "Simpan Kebenaran",
      "saveDenied": "Simpan Kebenaran yang Ditolak",
      "cancel": "Batal",
      "toast": {
        "updatedSuccess": "Kebenaran berjaya dikemas kini",
        "deniedUpdatedSuccess": "Kebenaran yang ditolak berjaya dikemas kini",
        "saveError": "Gagal menyimpan kebenaran",
        "saveDeniedError": "Gagal menyimpan kebenaran yang ditolak"
      },
      "permissionGroup": {
        "analytics": "Analitik",
        "audit": "Audit",
        "billing": "Pengebilan",
        "bloodProduct": "Produk Darah",
        "consent": "Kebenaran",
        "dietOrder": "Pesanan Diet",
        "discharge": "Discaj",
        "documentation": "Dokumentasi",
        "encounter": "Pertemuan",
        "infection": "Kawalan Jangkitan",
        "licensing": "Pelesenan",
        "medication": "Ubat",
        "notification": "Notifikasi",
        "order": "Pesanan",
        "patient": "Pesakit",
        "referral": "Rujukan",
        "research": "Penyelidikan",
        "restraint": "Sekatan",
        "result": "Keputusan",
        "scheduling": "Penjadualan",
        "system": "Sistem",
        "transfer": "Pemindahan",
        "user": "Pengguna",
        "schedule": "Jadual",
        "admin": "Pentadbiran",
        "report": "Laporan",
        "other": "Lain-lain"
      }
    }
  },
  "category": {
    "form": {
      "addTitle": "Cipta Kategori",
      "editTitle": "Edit Kategori",
      "fields": {
        "name": "Nama Kategori",
        "code": "Kod Kategori",
        "description": "Penerangan",
        "sessionTimeout": "Tamat Masa Sesi (minit)",
        "maxFailedLogins": "Maks. Log Masuk Gagal",
        "mfaRequired": "Wajibkan MFA untuk kategori ini"
      },
      "placeholders": {
        "code": "cth. CLINICAL"
      },
      "errors": {
        "nameRequired": "Nama kategori diperlukan",
        "codeRequired": "Kod kategori diperlukan"
      },
      "submit": {
        "create": "Cipta Kategori",
        "update": "Kemas Kini Kategori"
      },
      "cancel": "Batal",
      "toast": {
        "createdSuccess": "Kategori dicipta",
        "updatedSuccess": "Kategori dikemas kini",
        "saveError": "Gagal menyimpan kategori"
      }
    },
    "list": {},
    "auditLevel": {
      "none": "Tiada",
      "basic": "Asas",
      "full": "Penuh",
      "paranoid": "Sangat Ketat"
    },
    "permissions": {
      "title": "Kebenaran Lalai",
      "titleWithName": "Kebenaran Lalai — {{name}}",
      "subtitle": "Peranan dalam kategori ini mewarisi kebenaran ini melainkan ditolak secara eksplisit.",
      "invalidCategoryId": "ID kategori tidak sah.",
      "save": "Simpan Kebenaran Lalai",
      "cancel": "Batal",
      "toast": {
        "updatedSuccess": "Kebenaran lalai dikemas kini",
        "saveError": "Gagal menyimpan kebenaran lalai"
      }
    }
  },
  "permission": {
    "action": {
      "view": "Lihat",
      "viewSelf": "Lihat Sendiri",
      "viewRestricted": "Lihat Terhad",
      "read": "Baca",
      "write": "Tulis",
      "create": "Cipta",
      "update": "Kemas Kini",
      "modify": "Ubah Suai",
      "delete": "Padam",
      "merge": "Gabung",
      "discharge": "Discaj",
      "transfer": "Pemindahan",
      "approve": "Lulus",
      "cosign": "Tandatangan Bersama",
      "sign": "Tandatangan",
      "plan": "Rancang",
      "manage": "Urus",
      "all": "Semua",
      "breakGlass": "Akses Kecemasan",
      "export": "Eksport",
      "amend": "Pinda",
      "administer": "Beri",
      "doubleCheck": "Semakan Dua Kali",
      "reconcile": "Rekonsiliasi",
      "verbalVerify": "Pengesahan Pesanan Lisan",
      "verify": "Sahkan",
      "acknowledge": "Akui",
      "prescribe": "Preskripsi",
      "dispense": "Salur",
      "cancel": "Batal",
      "users": "Pengguna",
      "roles": "Peranan",
      "facilities": "Fasiliti",
      "system": "Sistem",
      "audit": "Log Audit"
    }
  },
  "access": {
    "title": "Matriks Akses",
    "subtitle": "Grid peranan × kebenaran",
    "searchPermission": "Cari kebenaran…",
    "searchRole": "Cari peranan…",
    "categoryFilter": "Kategori",
    "legend": {
      "own": "Sendiri",
      "inherited": "Diwarisi",
      "category": "Kategori",
      "denied": "Dinafikan",
      "none": "Tiada"
    },
    "cellTooltip": {
      "hasOwn": "Diberikan terus",
      "hasInherited": "Diwarisi daripada peranan induk: {{source}}",
      "hasCategory": "Diberikan melalui kategori: {{source}}",
      "denied": "Dinafikan secara eksplisit",
      "none": "Tidak diberikan"
    },
    "inheritedFrom": "Diwarisi daripada {{source}}",
    "bulkEdit": {
      "title": "Edit Pukal",
      "applyTo": "Gunakan pada yang dipilih",
      "selectedPermissions": "{{count}} kebenaran",
      "selectedRoles": "{{count}} peranan",
      "actionGrant": "Beri",
      "actionDeny": "Nafikan",
      "actionClear": "Kosongkan",
      "save": "Simpan perubahan",
      "cancel": "Batal"
    },
    "emptyRoles": "Tiada peranan yang sepadan dengan penapis.",
    "emptyPermissions": "Tiada kebenaran yang sepadan dengan penapis.",
    "loading": "Memuatkan matriks akses…",
    "permissionColumn": "Kebenaran",
    "rolePicker": {
      "trigger": "Pilih peranan untuk dibandingkan",
      "filterPlaceholder": "Tapis peranan…",
      "empty": "Tiada peranan yang sepadan.",
      "groupAll": "Semua",
      "groupNone": "Tiada",
      "footerSummary": "{{count}} daripada {{total}} dipilih",
      "selectAll": "Pilih semua",
      "clear": "Kosongkan"
    },
    "empty": {
      "selectRolesPrompt": "Pilih sekurang-kurangnya satu peranan untuk dibandingkan.",
      "selectAllRoles": "Pilih semua peranan",
      "noPermissions": "Tiada kebenaran ditemui."
    },
    "legendCategoryDefault": "Lalai Kategori",
    "legendNotGranted": "Tidak Diberikan",
    "page": {
      "title": "Matriks Akses",
      "subtitle": "Lihat dan urus peranan, kebenaran dan dasar akses"
    },
    "tabs": {
      "matrix": "Matriks Akses",
      "roles": "Pengurusan Peranan",
      "categories": "Pengurusan Kategori"
    },
    "roles": {
      "searchPlaceholder": "Cari peranan atau kebenaran...",
      "createButton": "Cipta Peranan",
      "columns": {
        "role": "Peranan",
        "category": "Kategori",
        "parent": "Peranan Induk",
        "permissions": "Kebenaran",
        "users": "Pengguna",
        "actions": "Tindakan"
      },
      "systemBadge": "Sistem",
      "managePermissionsTitle": "Urus kebenaran",
      "manageDeniedTitle": "Urus kebenaran yang dinafikan",
      "deniedBadge": "Dinafikan",
      "editTitle": "Edit peranan",
      "deleteTitle": "Padam peranan",
      "expandAria": "Kembangkan peranan",
      "collapseAria": "Runtuhkan peranan",
      "effectivePermissions": "Kebenaran Berkuat Kuasa",
      "noPermissionsAssigned": "Tiada kebenaran diberikan.",
      "empty": "Peranan tidak ditemui.",
      "delete": {
        "title": "Padam Peranan",
        "description": "Adakah anda pasti mahu memadam peranan \"{{name}}\"? Tindakan ini tidak boleh dibuat asal.",
        "confirm": "Padam"
      },
      "toast": {
        "deleted": "Peranan dipadam",
        "deleteError": "Gagal memadam peranan"
      }
    },
    "categories": {
      "subtitle": "Kategori mengumpulkan peranan dan menetapkan dasar dikongsi (MFA, had sesi).",
      "createButton": "Cipta Kategori",
      "requireMfa": "Perlukan MFA",
      "yes": "Ya",
      "no": "Tidak",
      "sessionTimeout": "Tamat Masa Sesi",
      "sessionTimeoutMinutes": "{{count}} min",
      "maxFailedLogins": "Maks Log Masuk Gagal",
      "manageDefaults": "Urus Kebenaran Lalai",
      "editTitle": "Edit",
      "editAria": "Edit kategori",
      "deleteTitle": "Padam",
      "deleteAria": "Padam kategori",
      "empty": "Belum ada kategori ditakrifkan.",
      "delete": {
        "title": "Padam Kategori",
        "description": "Adakah anda pasti mahu memadam kategori \"{{name}}\"? Tindakan ini tidak boleh dibuat asal.",
        "confirm": "Padam"
      },
      "toast": {
        "deleted": "Kategori dipadam",
        "deleteError": "Gagal memadam kategori"
      }
    },
    "confirm": {
      "bulkApply": "Gunakan {{count}} perubahan pada {{roleCount}} peranan?",
      "discardChanges": "Buang perubahan yang belum disimpan?"
    },
    "popover": {
      "grantTitle": "Beri kebenaran",
      "denyTitle": "Nafikan kebenaran",
      "clearTitle": "Kosongkan kebenaran",
      "grantNote": "Memberikan kebenaran ini akan menggantikan penafian yang diwarisi.",
      "denyNote": "Menafikan kebenaran ini akan menggantikan pemberian yang diwarisi.",
      "clearNote": "Mengosongkan akan kembali kepada tingkah laku yang diwarisi."
    },
    "toast": {
      "permissionGranted": "Kebenaran diberikan",
      "permissionDenied": "Kebenaran dinafikan",
      "permissionCleared": "Kebenaran dikosongkan",
      "bulkApplied": "Perubahan pukal digunakan",
      "saveError": "Gagal menyimpan perubahan"
    }
  },
  "confirm": {
    "restartIntegration": "Mulakan semula \"{{name}}\"? Sambungan aktif akan terputus sebentar semasa bahan TLS baharu dimuatkan.",
    "revokeFhirEndpoint": "Batalkan \"{{name}}\"? Panggilan keluar ke titik akhir ini akan berhenti.",
    "rotateSmartSecret": "Putarkan client secret untuk \"{{name}}\"? Secret lama akan berhenti berfungsi dengan serta-merta.",
    "revokeSmartApp": "Batalkan \"{{name}}\"? Permintaan token akan datang daripada aplikasi ini akan gagal.",
    "deactivateThirdPartyApp": "Nyahaktifkan \"{{name}}\"?"
  },
  "toast": {
    "tierCreated": "Peringkat dicipta",
    "tierCloned": "Peringkat diklon",
    "tierDeleted": "Peringkat dipadam",
    "tierStatusUpdated": "Status dikemas kini",
    "tierFeaturesUpdated": "Ciri dikemas kini",
    "tierLimitsUpdated": "Had dikemas kini",
    "tierSaveError": "Gagal mencipta peringkat",
    "tierValidation": "Nama dan kod diperlukan",
    "licenseKeyGenerated": "Kunci lesen dijana",
    "licenseKeyCopied": "Kunci lesen dijana dan disalin ke papan keratan",
    "overridesSaved": "Pengatasan disimpan",
    "pricingConfigSaved": "Konfigurasi disimpan",
    "pricingPriceUpdated": "Harga dikemas kini",
    "pricingRuleCreated": "Peraturan harga dicipta",
    "addonUpdated": "Modul tambahan dikemas kini",
    "invalidNumber": "Sila masukkan nombor yang sah",
    "csvExported": "Mengeksport {{filename}}",
    "integrationUpdated": "Integrasi dikemas kini",
    "integrationAdded": "Integrasi ditambah",
    "integrationInvalidConfig": "Konfigurasi tidak sah — semak hos/port dan medan TLS",
    "integrationDuplicateName": "Integrasi dengan nama itu sudah wujud",
    "integrationSaveFailed": "Gagal menyimpan integrasi",
    "smartAppRegistered": "Aplikasi SMART didaftarkan",
    "smartAppRegisterFailed": "Gagal mendaftarkan aplikasi SMART",
    "smartAppUpdated": "Aplikasi SMART dikemas kini",
    "smartAppUpdateFailed": "Gagal mengemas kini aplikasi SMART",
    "fhirEndpointUpdated": "Endpoint dikemas kini",
    "fhirEndpointRegistered": "Endpoint didaftarkan",
    "fhirEndpointInvalidConfig": "Konfigurasi tidak sah — semak base URL dan medan auth",
    "fhirEndpointDuplicateName": "Endpoint dengan nama itu sudah wujud",
    "fhirEndpointSaveFailed": "Gagal menyimpan endpoint",
    "clientIdCopied": "Client ID disalin",
    "clientSecretCopied": "Client secret disalin",
    "statusRefreshed": "Status disegar semula",
    "connTestOk": "Ujian sambungan berjaya",
    "connTestFailed": "Ujian sambungan gagal - semak konfigurasi endpoint",
    "serverRestarted": "Pelayan dimulakan semula — bahan TLS baharu berkuat kuasa",
    "clientReconnected": "Klien disambung semula — bahan TLS baharu berkuat kuasa",
    "notRunning": "Tidak berjalan — mulakan pelayan/klien untuk menggunakan konfigurasi",
    "restartFailed": "Gagal memulakan semula integrasi",
    "metadataOk": "/metadata OK{{detail}}",
    "metadataFailed": "/metadata gagal: {{error}}",
    "metadataProbeFailed": "Gagal menyiasat /metadata",
    "metadataUnknownError": "tidak diketahui",
    "fhirRevoked": "Endpoint FHIR dibatalkan",
    "fhirRevokeFailed": "Gagal membatalkan endpoint",
    "smartRevoked": "Aplikasi SMART dibatalkan",
    "smartRevokeFailed": "Gagal membatalkan aplikasi SMART",
    "secretRotated": "Rahsia klien diputar",
    "rotateSecretFailed": "Gagal memutar rahsia",
    "messageRequeued": "Mesej dibaris semula untuk dicuba lagi",
    "messageRetryFailed": "Cuba semula gagal",
    "messageSkipped": "Mesej dilangkau — baris gilir akan diteruskan",
    "messageSkipFailed": "Langkau gagal",
    "messageAbandoned": "Mesej ditinggalkan",
    "messageAbandonFailed": "Tinggalkan gagal",
    "messageResent": "Mesej dihantar semula sebagai baharu",
    "messageResendFailed": "Hantar semula gagal",
    "reasonRequired": "Sebab diperlukan",
    "copiedToClipboard": "Disalin ke papan keratan",
    "thirdPartyAppCreated": "Aplikasi pihak ketiga berjaya dicipta",
    "thirdPartyAppUpdated": "Aplikasi pihak ketiga berjaya dikemas kini",
    "thirdPartyAppDeactivated": "Aplikasi pihak ketiga dinyahaktifkan",
    "thirdPartyAppLaunchUrl": "URL pelancaran dijana: {{url}}"
  },
  "facility": {
    "form": {
      "addTitle": "Tambah Fasiliti",
      "editTitle": "Sunting Fasiliti",
      "fields": {
        "name": "Nama",
        "code": "Kod",
        "type": "Jenis",
        "address": "Alamat",
        "city": "Bandar",
        "stateProvince": "Negeri/Wilayah",
        "country": "Negara",
        "phone": "Telefon",
        "timeZone": "Zon Waktu",
        "healthSystem": "Health System",
        "visibilityScope": "Patient visibility override",
        "visibilityScopeDesc": "Narrow or widen patient visibility for this facility. The stricter side always wins between the user's and the patient's facility. Takes effect immediately.",
        "visibilityInherit": "Inherit global default"
      },
      "placeholders": {
        "timeZone": "Contoh: Asia/Bangkok",
        "healthSystem": "Select a health system"
      },
      "helper": {
        "timeZone": "Nama zon waktu IANA (contoh: Asia/Singapore). Digunakan untuk tarikh tempatan fasiliti dalam banci pesakit, MAR dan laporan."
      },
      "options": {
        "otherIana": "Lain-lain (IANA)…",
        "useCuratedList": "Gunakan senarai pilihan"
      },
      "errors": {
        "nameMin": "Nama fasiliti mestilah sekurang-kurangnya {{min}} aksara",
        "codeFormat": "Kod hanya boleh mengandungi huruf besar dan nombor",
        "typeRequired": "Jenis fasiliti diperlukan",
        "countryRequired": "Negara diperlukan",
        "timeZoneRequired": "Zon waktu diperlukan",
        "timeZoneInvalidIana": "Pelayan menolak zon waktu ini. Sila gunakan nama IANA yang sah (contoh: Asia/Singapore).",
        "healthSystemRequired": "Health system is required"
      },
      "submit": {
        "create": "Cipta",
        "update": "Kemas Kini"
      },
      "cancel": "Batal",
      "toast": {
        "createdSuccess": "Fasiliti berjaya dicipta",
        "updatedSuccess": "Fasiliti berjaya dikemas kini",
        "saveError": "Gagal menyimpan fasiliti",
        "invalidTimeZone": "Permintaan tidak sah — sila pastikan zon waktu adalah nama IANA yang sah (contoh: Asia/Singapore)."
      },
      "memberships": {
        "title": "Group Memberships",
        "columns": {
          "group": "Group",
          "role": "Role",
          "effective": "Effective",
          "end": "End",
          "status": "Status",
          "actions": "Actions"
        },
        "add": {
          "healthSystem": "Health system",
          "role": "Role",
          "effective": "Effective date",
          "end": "End date (optional)",
          "submit": "Add membership"
        },
        "roles": {
          "primary": "Primary",
          "member": "Member",
          "partner": "Partner"
        },
        "endMembership": "End membership",
        "toast": {
          "createdSuccess": "Membership added",
          "updatedSuccess": "Membership updated",
          "endedSuccess": "Membership ended",
          "saveError": "Failed to save membership",
          "conflict": "An open membership for this facility and group already exists"
        }
      },
      "__review_healthSystem": "EN placeholder — needs translation"
    },
    "list": {
      "title": "Pengurusan Kemudahan",
      "subtitle": "Kemudahan, jabatan, dan (melalui pokok ini) gambaran sekilas hierarki lokasi fizikal. Untuk pokok lokasi penuh (bangunan → tingkat → unit → bilik → katil), lihat <locationsLink>Lokasi</locationsLink>.",
      "columns": {
        "name": "Nama",
        "code": "Kod",
        "type": "Jenis",
        "address": "Alamat",
        "phone": "Telefon",
        "depts": "Jabatan",
        "status": "Status",
        "actions": "Tindakan"
      },
      "filter": {
        "search": "Cari kemudahan..."
      },
      "actions": {
        "new": "Tambah Kemudahan",
        "editTitle": "Edit"
      },
      "expand": {
        "expand": "Kembangkan kemudahan",
        "collapse": "Runtuhkan kemudahan"
      },
      "empty": {
        "noMatch": "Tiada kemudahan sepadan dengan carian itu.",
        "none": "Tiada kemudahan lagi — klik Tambah Kemudahan untuk bermula."
      },
      "departments": {
        "title": "Jabatan",
        "add": "Tambah Jabatan",
        "empty": "Tiada jabatan dikonfigurasikan",
        "locationsCount": "{{count}} lokasi",
        "editTitle": "Edit jabatan"
      },
      "locations": {
        "title": "Lokasi",
        "add": "Tambah",
        "empty": "Tiada lokasi dalam jabatan ini. Pokok lokasi (bangunan → tingkat → unit → katil) diuruskan di <locationsLink>Lokasi</locationsLink>."
      }
    },
    "type": {
      "generalHospital": "Hospital Am",
      "teachingHospital": "Hospital Pengajaran",
      "specialtyHospital": "Hospital Pakar",
      "communityHospital": "Hospital Komuniti",
      "clinic": "Klinik"
    },
    "status": {
      "active": "Aktif",
      "inactive": "Tidak Aktif"
    }
  },
  "healthSystem": {
    "form": {
      "addTitle": "Tambah Sistem Kesihatan",
      "editTitle": "Edit Sistem Kesihatan",
      "subtitle": "Tahap teratas dalam struktur organisasi. Induk kepada satu atau lebih kemudahan.",
      "sections": {
        "identity": "Identiti",
        "primaryContact": "Hubungan utama",
        "address": "Alamat"
      },
      "fields": {
        "code": "Kod",
        "name": "Nama",
        "taxId": "No. Cukai",
        "contactName": "Nama",
        "contactEmail": "E-mel",
        "contactPhone": "Telefon",
        "addressLine1": "Alamat baris 1",
        "addressLine2": "Alamat baris 2",
        "city": "Bandar",
        "stateProvince": "Negeri",
        "postalCode": "Poskod",
        "country": "Negara",
        "active": "Aktif — nyahtanda untuk menyahaktifkan."
      },
      "placeholders": {
        "code": "VYNAEMR-SG",
        "name": "VynaEMR Singapore",
        "taxId": "UEN / Tax ID",
        "country": "SG"
      },
      "helper": {
        "codeImmutable": "Kod tidak boleh diubah selepas dibuat."
      },
      "errors": {
        "codeRequired": "Kod diperlukan",
        "nameRequired": "Nama diperlukan"
      },
      "submit": {
        "create": "Cipta Sistem Kesihatan",
        "update": "Simpan Perubahan"
      },
      "cancel": "Batal",
      "toast": {
        "createdSuccess": "Sistem kesihatan berjaya dicipta",
        "updatedSuccess": "Sistem kesihatan berjaya dikemas kini",
        "saveError": "Gagal menyimpan sistem kesihatan",
        "codeConflict": "Kod sistem sudah wujud",
        "invalidData": "Data sistem kesihatan tidak sah"
      }
    },
    "list": {
      "title": "Sistem Kesihatan",
      "subtitle": "Puncak pokok organisasi — perusahaan / sistem kesihatan induk yang memiliki satu atau lebih kemudahan. Jarang diubah selepas persediaan awal.",
      "columns": {
        "name": "Nama",
        "code": "Kod",
        "contact": "Hubungan",
        "location": "Lokasi",
        "facilities": "Kemudahan",
        "status": "Status",
        "actions": "Tindakan"
      },
      "filter": {
        "search": "Cari mengikut nama atau kod..."
      },
      "actions": {
        "new": "Tambah Sistem Kesihatan",
        "editTitle": "Edit"
      },
      "status": {
        "active": "Aktif",
        "inactive": "Tidak Aktif"
      },
      "empty": {
        "noMatch": "Tiada sistem kesihatan sepadan dengan carian itu.",
        "none": "Tiada sistem kesihatan lagi — klik Tambah Sistem Kesihatan untuk bermula."
      }
    }
  },
  "location": {
    "form": {
      "addTitle": "Tambah Lokasi",
      "editTitle": "Edit Lokasi",
      "subtitle": "Lokasi fizikal — bangunan, tingkat, unit, bilik, atau katil. Serasi FHIR R4 Location. Bersarang melalui lokasi induk untuk membina pokok hierarki.",
      "sections": {
        "hierarchy": "Hierarki",
        "identity": "Identiti",
        "classification": "Klasifikasi",
        "physicalAttributes": "Atribut fizikal"
      },
      "fields": {
        "facility": "Kemudahan",
        "parentLocation": "Lokasi induk",
        "department": "Jabatan (pilihan)",
        "code": "Kod",
        "abbreviation": "Singkatan",
        "name": "Nama",
        "physicalType": "Jenis fizikal (FHIR)",
        "clinicalType": "Jenis klinikal",
        "status": "Status (FHIR)",
        "operationalStatus": "Status operasi (HL7 0116)",
        "building": "Bangunan",
        "floor": "Tingkat",
        "wing": "Sayap",
        "roomNumber": "Nombor bilik",
        "bedIdentifier": "Pengecam katil",
        "capacity": "Kapasiti",
        "active": "Aktif (bendera lama)"
      },
      "placeholders": {
        "facility": "Pilih kemudahan…",
        "parentNone": "Tiada (peringkat atas)",
        "departmentNone": "Tiada",
        "code": "4W-12-A",
        "name": "4W-12 Katil A",
        "building": "A",
        "floor": "4",
        "wing": "West",
        "roomNumber": "4W-12",
        "bedIdentifier": "A"
      },
      "helper": {
        "physicalType": "Set nilai FHIR LocationPhysicalType.",
        "clinicalType": "Lama; buang apabila service_type tiba."
      },
      "physicalAttributes": {
        "show": "Tunjuk ▾",
        "hide": "Sembunyi ▴"
      },
      "errors": {
        "facilityRequired": "Kemudahan diperlukan",
        "codeRequired": "Kod diperlukan",
        "nameRequired": "Nama diperlukan"
      },
      "submit": {
        "create": "Cipta Lokasi",
        "update": "Simpan Perubahan"
      },
      "cancel": "Batal",
      "toast": {
        "createdSuccess": "Lokasi berjaya dicipta",
        "updatedSuccess": "Lokasi berjaya dikemas kini",
        "saveError": "Gagal menyimpan lokasi",
        "codeConflict": "Kod lokasi sudah wujud",
        "invalidData": "Data lokasi tidak sah"
      }
    },
    "list": {
      "title": "Hierarki Lokasi",
      "subtitle": "Pokok fizikal: bangunan → tingkat → unit → bilik → katil. Sejajar dengan FHIR LocationPhysicalType. Klik lencana status katil untuk mengitar penghunian. Kemudahan dan jabatan diurus dalam <facilitiesLink>Kemudahan</facilitiesLink>.",
      "filter": {
        "search": "Cari mengikut nama atau kod...",
        "allFacilities": "Semua kemudahan"
      },
      "actions": {
        "new": "Tambah Lokasi",
        "addChildTitle": "Tambah anak",
        "editTitle": "Sunting"
      },
      "expand": {
        "expand": "Kembangkan lokasi",
        "collapse": "Runtuhkan lokasi"
      },
      "bed": {
        "toggleTitle": "Klik untuk tukar kepada {{next}}"
      },
      "empty": {
        "noMatch": "Tiada lokasi sepadan dengan carian itu.",
        "none": "Belum ada lokasi dalam kemudahan ini."
      },
      "toast": {
        "bedStatusUpdated": "Status katil dikemas kini",
        "bedStatusError": "Gagal mengemas kini status katil"
      }
    },
    "type": {
      "si": "Tapak",
      "bu": "Bangunan",
      "wi": "Sayap",
      "wa": "Wad",
      "lvl": "Tingkat",
      "co": "Koridor",
      "ro": "Bilik",
      "bd": "Katil",
      "ve": "Maya",
      "ho": "Rumah",
      "ca": "Kabinet",
      "rd": "Jalan",
      "area": "Kawasan",
      "jdn": "Bidang Kuasa"
    },
    "clinicalType": {
      "examRoom": "Bilik pemeriksaan",
      "inpatientBed": "Katil pesakit dalam",
      "procedureRoom": "Bilik prosedur",
      "icu": "ICU",
      "ed": "Kecemasan",
      "or": "Bilik bedah",
      "virtual": "Maya"
    },
    "status": {
      "active": "Aktif",
      "suspended": "Digantung",
      "inactive": "Tidak Aktif",
      "op": {
        "O": "Diisi",
        "U": "Kosong",
        "H": "Pembersihan",
        "K": "Tercemar",
        "I": "Pengasingan",
        "C": "Ditutup"
      }
    },
    "capability": {
      "isolation": "Mampu pengasingan",
      "negativePressure": "Tekanan negatif",
      "bariatric": "Mampu bariatrik",
      "telemetry": "Mampu telemetri",
      "icu": "Tahap ICU"
    }
  },
  "department": {
    "form": {
      "addTitle": "Tambah Jabatan",
      "editTitle": "Sunting Jabatan",
      "subtitle": "Unit organisasi dalam fasiliti. Boleh bersarang (cth., Kardiologi → Makmal EP) melalui jabatan induk.",
      "sections": {
        "department": "Jabatan"
      },
      "fields": {
        "facility": "Fasiliti",
        "code": "Kod",
        "abbreviation": "Singkatan",
        "name": "Nama",
        "type": "Jenis",
        "parentDepartment": "Jabatan induk",
        "costCenterCode": "Kod pusat kos",
        "revenueDepartmentCode": "Kod jabatan hasil",
        "active": "Aktif — nyahtanda untuk menyahaktifkan secara lembut."
      },
      "placeholders": {
        "facility": "Pilih fasiliti…",
        "code": "CARDIO",
        "abbreviation": "CARD",
        "name": "Kardiologi",
        "parentNone": "Tiada (peringkat teratas)",
        "typeNone": "—",
        "costCenterCode": "CC-CARDIO",
        "revenueDepartmentCode": "RD-410"
      },
      "errors": {
        "facilityRequired": "Fasiliti diperlukan",
        "codeRequired": "Kod diperlukan",
        "nameRequired": "Nama diperlukan"
      },
      "submit": {
        "create": "Cipta Jabatan",
        "update": "Simpan Perubahan"
      },
      "cancel": "Batal",
      "toast": {
        "createdSuccess": "Jabatan berjaya dicipta",
        "updatedSuccess": "Jabatan berjaya dikemas kini",
        "saveError": "Gagal menyimpan jabatan",
        "codeConflict": "Kod jabatan sudah wujud",
        "invalidData": "Data jabatan tidak sah"
      }
    },
    "serviceType": {
      "clinical": "Klinikal",
      "administrative": "Pentadbiran",
      "support": "Sokongan"
    },
    "status": {
      "active": "Aktif",
      "inactive": "Tidak aktif"
    }
  },
  "provider": {
    "form": {
      "addTitle": "Tambah Pengamal",
      "editTitle": "Edit Pengamal",
      "fields": {
        "fullName": "Nama Penuh",
        "npi": "NPI",
        "providerType": "Jenis Penyedia",
        "credentials": "Kelayakan",
        "specialty": "Pengkhususan",
        "email": "E-mel",
        "phone": "Telefon",
        "facilityAssignments": "Tugasan Kemudahan",
        "status": "Status",
        "primaryFacility": "Fasiliti Utama",
        "loginAccount": "Akaun Log Masuk"
      },
      "placeholders": {
        "specialty": "Pilih pengkhususan…",
        "credentials": "cth. MD, FACC",
        "providerType": "Pilih jenis penyedia",
        "noLoginAccount": "Tiada akaun log masuk"
      },
      "submit": {
        "create": "Cipta",
        "update": "Kemas Kini"
      },
      "cancel": "Batal",
      "toast": {
        "createdSuccess": "Pengamal dicipta",
        "updatedSuccess": "Pengamal dikemas kini",
        "saveError": "Gagal menyimpan pengamal"
      },
      "hints": {
        "loginAccount": "Memautkan klinisi ini dengan akaun yang digunakannya untuk log masuk. Tanpanya, tandatangan bersama, pengesahan ahli farmasi dan pengakuan keputusan kritikal akan ditolak."
      }
    },
    "list": {
      "title": "Pengurusan Penyedia",
      "subtitle": "Urus penyedia, kelayakan, dan tugasan kemudahan",
      "columns": {
        "name": "Nama",
        "npi": "NPI",
        "specialty": "Kepakaran",
        "credentials": "Kelayakan",
        "facilities": "Kemudahan",
        "status": "Status",
        "actions": "Tindakan"
      },
      "filter": {
        "search": "Cari mengikut nama, NPI, kepakaran...",
        "allSpecialties": "Semua Kepakaran",
        "allFacilities": "Semua Kemudahan",
        "allStatus": "Semua Status"
      },
      "actions": {
        "new": "Tambah Penyedia",
        "editTitle": "Sunting penyedia",
        "scheduleTitle": "Templat jadual",
        "viewCredentials": "Lihat kelayakan"
      },
      "credentials": {
        "licenseLabel": "Lesen",
        "none": "Tiada kelayakan dalam fail"
      },
      "empty": "Tiada penyedia dijumpai",
      "pagination": {
        "summary": "{{from}}-{{to}} daripada {{total}}",
        "pageOf": "{{page}}/{{totalPages}}",
        "previous": "Halaman sebelumnya",
        "next": "Halaman seterusnya"
      },
      "toast": {
        "schedulePlaceholder": "Pautan templat jadual (placeholder)"
      },
      "noLogin": "Tiada log masuk",
      "noLoginHint": "Penyedia ini tiada akaun log masuk terpaut, jadi tidak boleh menandatangani bersama, mengesah atau mengaku."
    },
    "specialty": {
      "internalMedicine": "Perubatan Dalaman",
      "cardiology": "Kardiologi",
      "emergencyMedicine": "Perubatan Kecemasan",
      "pediatrics": "Pediatrik",
      "pathology": "Patologi",
      "obstetricsGynecology": "Obstetrik & Ginekologi",
      "surgery": "Pembedahan",
      "orthopedics": "Ortopedik",
      "neurology": "Neurologi",
      "psychiatry": "Psikiatri",
      "radiology": "Radiologi",
      "anesthesiology": "Anestesiologi",
      "oncology": "Onkologi",
      "dermatology": "Dermatologi",
      "ophthalmology": "Oftalmologi"
    },
    "status": {
      "active": "Aktif",
      "inactive": "Tidak Aktif",
      "onLeave": "Bercuti"
    },
    "providerType": {
      "physician": "Doktor",
      "nurse": "Jururawat",
      "nursePractitioner": "Jururawat Pengamal",
      "physicianAssistant": "Pembantu Doktor",
      "pharmacist": "Ahli Farmasi",
      "therapist": "Ahli Terapi",
      "technician": "Juruteknik",
      "other": "Lain-lain",
      "midwife": "Bidan",
      "dentist": "Doktor Gigi",
      "pharmacyTechnician": "Juruteknik Farmasi",
      "careAssistant": "Pembantu Perawatan",
      "dietitian": "Ahli Diet",
      "socialWorker": "Pekerja Sosial",
      "traditionalMedicine": "Pengamal Perubatan Tradisional"
    }
  },
  "serviceLine": {
    "form": {
      "addTitle": "Tambah Lini Perkhidmatan",
      "editTitle": "Edit Lini Perkhidmatan",
      "subtitle": "Pengelompokan klinikal peringkat tinggi (Kardiovaskular, Onkologi) yang menjadi induk kepada perkhidmatan klinikal tertentu.",
      "sections": {
        "serviceLine": "Lini Perkhidmatan"
      },
      "fields": {
        "healthSystem": "Sistem Kesihatan",
        "code": "Kod",
        "name": "Nama",
        "description": "Penerangan",
        "active": "Aktif — nyahtanda untuk menyahaktifkan secara lembut."
      },
      "placeholders": {
        "healthSystem": "Pilih sistem kesihatan…",
        "code": "CV",
        "name": "Cardiovascular",
        "description": "Penerangan ringkas — skop, fokus penyakit, dll."
      },
      "errors": {
        "healthSystemRequired": "Sistem kesihatan diperlukan",
        "codeRequired": "Kod diperlukan",
        "nameRequired": "Nama diperlukan"
      },
      "submit": {
        "create": "Cipta Lini Perkhidmatan",
        "update": "Simpan Perubahan"
      },
      "cancel": "Batal",
      "toast": {
        "createdSuccess": "Lini perkhidmatan dicipta",
        "updatedSuccess": "Lini perkhidmatan dikemas kini",
        "saveError": "Gagal menyimpan lini perkhidmatan",
        "codeConflict": "Kod lini perkhidmatan sudah wujud",
        "invalidData": "Data lini perkhidmatan tidak sah"
      }
    },
    "category": {}
  },
  "clinicalService": {
    "form": {
      "addTitle": "Tambah Perkhidmatan Klinikal",
      "editTitle": "Edit Perkhidmatan Klinikal",
      "subtitle": "Perkhidmatan klinikal khusus (Kardiologi, Makmal EP). Boleh dikumpulkan di bawah lini perkhidmatan + ditandakan dengan kod kepakaran NUCC untuk pengebilan + output direktori.",
      "sections": {
        "clinicalService": "Perkhidmatan Klinikal",
        "specialtyBilling": "Kepakaran + Pengebilan"
      },
      "fields": {
        "code": "Kod",
        "name": "Nama",
        "serviceLine": "Lini Perkhidmatan",
        "description": "Penerangan",
        "specialtyCode": "Kod kepakaran NUCC",
        "specialtyDescription": "Penerangan kepakaran",
        "revenueDepartmentCode": "Kod jabatan hasil",
        "active": "Aktif"
      },
      "placeholders": {
        "code": "CARDIO-EP",
        "name": "Electrophysiology",
        "serviceLineNone": "— tiada —",
        "specialtyCode": "207RE0101X",
        "specialtyDescription": "Clinical Cardiac Electrophysiology",
        "revenueDepartmentCode": "RD-480"
      },
      "helper": {
        "specialtyCode": "Taksonomi NUCC — memacu direktori penyedia + paparan tuntutan."
      },
      "errors": {
        "codeRequired": "Kod diperlukan",
        "nameRequired": "Nama diperlukan"
      },
      "submit": {
        "create": "Cipta Perkhidmatan Klinikal",
        "update": "Simpan Perubahan"
      },
      "cancel": "Batal",
      "toast": {
        "createdSuccess": "Perkhidmatan klinikal dicipta",
        "updatedSuccess": "Perkhidmatan klinikal dikemas kini",
        "saveError": "Gagal menyimpan perkhidmatan klinikal",
        "codeConflict": "Kod perkhidmatan klinikal sudah wujud",
        "invalidData": "Data perkhidmatan klinikal tidak sah"
      }
    },
    "flag": {}
  },
  "serviceLocation": {
    "title": "Penugasan Perkhidmatan ↔ Lokasi",
    "subtitle": "Perkhidmatan klinikal yang dijalankan di lokasi fizikal mana, dengan tetingkap hari/masa dan kapasiti pilihan. Penjadualan membaca ini untuk membina slot yang tersedia. Hanya padam lembut — menamatkan penugasan mengekalkan sejarah untuk laporan.",
    "header": {
      "newAssignment": "Penugasan Baharu",
      "toggleCancel": "Batal"
    },
    "form": {
      "title": "Penugasan baharu",
      "fields": {
        "service": "Perkhidmatan Klinikal",
        "location": "Lokasi",
        "dayOfWeekPattern": "Corak hari dalam minggu",
        "startTime": "Masa mula",
        "endTime": "Masa tamat",
        "capacity": "Kapasiti %",
        "notes": "Nota",
        "isPrimary": "Lokasi utama untuk perkhidmatan ini"
      },
      "placeholders": {
        "service": "Pilih perkhidmatan…",
        "location": "Pilih lokasi…",
        "dayOfWeekPattern": "1,3,5 (Isn/Rab/Jum)",
        "capacity": "0–100"
      },
      "helper": {
        "dayOfWeekPattern": "Hari ISO dipisah koma; kosong = setiap hari."
      },
      "errors": {
        "serviceLocationRequired": "Perkhidmatan + Lokasi diperlukan"
      },
      "create": "Cipta",
      "cancel": "Batal"
    },
    "filter": {
      "allFacilities": "Semua kemudahan",
      "allServices": "Semua perkhidmatan",
      "allLocations": "Semua lokasi",
      "allStatuses": "Semua status",
      "searchService": "Cari perkhidmatan…",
      "searchLocation": "Cari lokasi…",
      "facility": "Kemudahan",
      "serviceLine": "Lini perkhidmatan"
    },
    "columns": {
      "service": "Perkhidmatan",
      "location": "Lokasi",
      "facility": "Kemudahan",
      "when": "Bila",
      "capacity": "Kapasiti",
      "effective": "Berkuat kuasa",
      "status": "Status",
      "actions": "Tindakan"
    },
    "status": {
      "active": "Aktif",
      "planned": "Dirancang",
      "suspended": "Digantung",
      "ended": "Tamat"
    },
    "dow": {
      "everyDay": "Setiap hari",
      "monFri": "Isn–Jum",
      "short": {
        "1": "Isn",
        "2": "Sel",
        "3": "Rab",
        "4": "Kha",
        "5": "Jum",
        "6": "Sab",
        "7": "Aha"
      }
    },
    "cell": {
      "none": "—",
      "primaryAria": "Lokasi utama",
      "effectiveEndPrefix": "→ {{date}}"
    },
    "actions": {
      "setPrimary": "Jadikan utama",
      "unsetPrimary": "Nyahtetap utama",
      "endAssignment": "Tamatkan penugasan"
    },
    "bulkEdit": {
      "title": "Edit Pukal",
      "applyTo": "Guna pada yang dipilih",
      "selectedServices": "{{count}} perkhidmatan",
      "selectedLocations": "{{count}} lokasi",
      "save": "Simpan perubahan",
      "cancel": "Batal"
    },
    "confirm": {
      "endTitle": "Tamatkan penugasan?",
      "endDescription": "{{service}} → {{location}}. Menamatkan mengekalkan sejarah tetapi mengeluarkan pasangan ini daripada penjadualan aktif.",
      "endConfirm": "Tamatkan penugasan",
      "removeService": "Keluarkan {{service}} daripada {{location}}?",
      "makePrimary": "Jadikan {{location}} lokasi utama untuk {{service}}?"
    },
    "toast": {
      "created": "Penugasan dicipta",
      "createError": "Gagal mencipta penugasan",
      "ended": "Penugasan ditamatkan",
      "endError": "Gagal menamatkan penugasan",
      "primaryError": "Gagal menukar utama",
      "updated": "Penugasan dikemas kini"
    },
    "empty": "Tiada penugasan sepadan dengan penapis ini. Klik Penugasan Baharu untuk menambah."
  },
  "integration": {
    "list": {
      "title": "Pengurusan Integrasi",
      "subtitle": "Integrasi sistem HL7, FHIR, dan pihak ketiga",
      "refresh": "Segar semula",
      "addEndpoint": "Tambah Endpoint",
      "searchPlaceholder": "Cari integrasi…",
      "tabs": {
        "endpoints": "Endpoint",
        "messageLog": "Log Mesej",
        "fhirSmart": "FHIR / SMART"
      },
      "cards": {
        "totalEndpoints": "Jumlah Endpoint",
        "connected": "Disambung",
        "errors": "Ralat",
        "totalMessages": "Jumlah Mesej"
      }
    },
    "columns": {
      "status": "Status",
      "name": "Nama",
      "type": "Jenis",
      "direction": "Arah",
      "url": "URL",
      "tls": "TLS",
      "auth": "Auth",
      "lastMessage": "Mesej Terakhir",
      "messages": "Mesej",
      "errors": "Ralat",
      "backlog": "Tunggakan",
      "health": "Kesihatan",
      "actions": "Tindakan",
      "backlogTitle": "Mesej keluar belum selesai + usia tertunda terlama",
      "healthTitle": "Status kesihatan — merah jika baris gilir disekat oleh mesej yang gagal"
    },
    "badge": {
      "tlsCerts": "sijil: {{cert}}, kunci: {{key}}, CA: {{ca}}",
      "yes": "ya",
      "no": "tidak",
      "basicTitle": "basic ({{username}})",
      "bearerStored": "Token Bearer disimpan",
      "bearerNoToken": "bearer (token belum ditetapkan)",
      "mtlsCert": "Sijil klien mTLS",
      "awaitingAck": "{{n}} menunggu ACK",
      "oldest": "tertua {{age}}",
      "never": "Tidak pernah",
      "blocked": "DISEKAT",
      "waiting": "MENUNGGU",
      "ok": "OK",
      "blockedTitle": "Mesej yang gagal menyekat baris gilir integrasi ini. Klik untuk membuka log ditapis.",
      "waitingTitle": "Mesej menunggu ACK aplikasi mod dipertingkat daripada rakan kongsi. Klik untuk membuka log ditapis.",
      "okTitle": "Semua hijau — klik untuk membuka log mesej integrasi ini.",
      "receives": "Menerima"
    },
    "action": {
      "testConnection": "Uji sambungan",
      "restartTls": "Mula semula — gunakan TLS yang baru diputar",
      "investigate": "Throughput, latensi, dan kegagalan terkini",
      "edit": "Edit"
    },
    "auth": {
      "basic": "Basic",
      "bearer": "Bearer",
      "mtls": "mTLS"
    },
    "fhirAuth": {
      "basic": "Basic",
      "bearer": "Bearer",
      "oauth2": "OAuth2",
      "mtls": "mTLS"
    },
    "messages": {
      "recent50": "50 mesej terkini",
      "columns": {
        "time": "Masa",
        "id": "ID",
        "direction": "Arah",
        "type": "Jenis",
        "source": "Sumber",
        "summary": "Ringkasan",
        "status": "Status"
      },
      "dir": {
        "in": "MASUK",
        "out": "KELUAR"
      }
    },
    "fhir": {
      "serverStatusHeader": "Status Pelayan FHIR R4",
      "serverOnline": "Pelayan Dalam Talian",
      "supportedResources": "Sumber Disokong",
      "version": "Versi",
      "externalHeader": "Endpoint FHIR Luaran",
      "registerEndpoint": "Daftar Endpoint",
      "columns": {
        "name": "Nama",
        "baseUrl": "URL Asas",
        "auth": "Auth",
        "status": "Status",
        "lastChecked": "Semakan Terakhir",
        "actions": "Tindakan"
      },
      "emptyEndpoints": "Belum ada endpoint FHIR luaran didaftarkan.",
      "revoked": "dibatalkan",
      "statusOk": "OK",
      "statusError": "Ralat",
      "testMetadata": "Uji /metadata",
      "edit": "Edit",
      "revoke": "Batal"
    },
    "smart": {
      "header": "Aplikasi SMART Berdaftar",
      "registerApp": "Daftar Aplikasi",
      "columns": {
        "appName": "Nama Aplikasi",
        "clientId": "Client ID",
        "scopes": "Skop",
        "status": "Status",
        "lastModified": "Terakhir Diubah",
        "actions": "Tindakan"
      },
      "emptyApps": "Belum ada aplikasi SMART didaftarkan.",
      "edit": "Edit",
      "rotateSecret": "Putar rahsia klien",
      "revoke": "Batal"
    },
    "secretModal": {
      "title": "Simpan client secret ini sekarang",
      "body": "Secret ini dipaparkan sekali sahaja. Jika hilang, gilirkan secret untuk mengeluarkan yang baharu.",
      "clientId": "Client ID",
      "clientSecret": "Client Secret",
      "copyClientId": "Salin Client ID",
      "copyClientSecret": "Salin Client Secret",
      "saved": "Saya telah menyimpannya"
    },
    "drawer": {
      "header": "Integrasi #{{id}}",
      "refresh": "Muat semula",
      "close": "Tutup",
      "queueBlocked": "Baris gilir disekat",
      "queueBlockedBody": "Mesej yang gagal menghalang integrasi ini daripada menghantar. Mesej di belakangnya menunggu sehingga pengendali bertindak.",
      "investigate": "Siasat",
      "tiles": {
        "backlog": "Tunggakan",
        "success24h": "Berjaya 24h",
        "avgLatency24h": "Latensi purata 24h",
        "awaitingAck": "Menunggu app-ACK"
      },
      "charts": {
        "throughput": "Throughput (24h)",
        "throughputSub": "Baldi setiap jam. Bertindan: keluar selesai + gagal; masuk pada paksi sekunder.",
        "successRate": "Kadar kejayaan (24h)",
        "successRateSub": "Setiap baldi: selesai / (selesai + gagal). Jurang ialah baldi melahu.",
        "ackLatency": "Latensi ACK (24h)",
        "ackLatencySub": "Masa antara hantar dan ACK diterima. avg garis penuh, p95 putus-putus."
      },
      "series": {
        "outCompleted": "Keluar · selesai",
        "outFailed": "Keluar · gagal",
        "inReceived": "Masuk · diterima",
        "successPct": "Berjaya %",
        "avg": "avg",
        "p95": "p95"
      },
      "recentFailures": "Kegagalan terkini",
      "viewAll": "Lihat semua →",
      "noFailures": "Tiada mesej gagal dalam tetingkap terkini. 🎉"
    }
  },
  "integrationStatus": {
    "connected": "Disambung",
    "disconnected": "Terputus",
    "error": "Ralat"
  },
  "integrationDirection": {
    "server": "Pelayan",
    "client": "Klien"
  },
  "messageStatus": {
    "sent": "Dihantar",
    "received": "Diterima",
    "error": "Ralat",
    "acknowledged": "Diakui"
  },
  "smartAppStatus": {
    "active": "Aktif",
    "revoked": "Dibatalkan"
  },
  "interfaceMessageStatus": {
    "pending": "Tertunda",
    "processing": "Memproses",
    "completed": "Selesai",
    "received": "Diterima",
    "processed": "Diproses",
    "failed": "Gagal",
    "error": "Ralat",
    "rejected": "Ditolak",
    "deadLetter": "Surat Mati",
    "skipped": "Dilangkau",
    "awaitingAppAck": "Menunggu ACK Aplikasi"
  },
  "interfaceDirection": {
    "in": "Masuk",
    "out": "Keluar"
  },
  "attemptOutcome": {
    "sent": "Dihantar",
    "appNak": "App NAK",
    "timeout": "Tamat masa",
    "networkError": "Ralat rangkaian"
  },
  "fhirEndpoint": {
    "titleEdit": "Edit Endpoint FHIR",
    "titleRegister": "Daftarkan Endpoint FHIR",
    "subtitle": "Rakan FHIR R4 luaran yang dihubungi gateway secara outbound. Butang Test Connection pada senarai integrasi menduga <code>/metadata</code> dengan auth + TLS yang dikonfigurasikan.",
    "back": "Kembali",
    "cancel": "Batal",
    "storedBlank": "Disimpan — biarkan kosong untuk mengekalkan",
    "save": {
      "changes": "Simpan Perubahan",
      "register": "Daftarkan Endpoint"
    },
    "section": {
      "basics": "Asas",
      "auth": "Pengesahan",
      "tls": "TLS"
    },
    "fields": {
      "name": "Nama",
      "baseUrl": "Base URL",
      "description": "Penerangan",
      "active": "Aktif — nyahtanda untuk soft-revoke.",
      "method": "Kaedah",
      "username": "Nama pengguna",
      "password": "Kata laluan",
      "bearerToken": "Bearer token",
      "tokenUrl": "Token URL",
      "clientId": "Client ID",
      "clientSecret": "Client Secret",
      "scope": "Scope"
    },
    "placeholder": {
      "name": "Partner Hospital FHIR",
      "baseUrl": "https://partner.example.com/fhir/R4",
      "tokenUrl": "https://partner.example.com/oauth/token",
      "scope": "system/*.read"
    },
    "helper": {
      "baseUrl": "https:// diperlukan (http://localhost diterima untuk pembangunan). /metadata di hujung ditambah secara automatik semasa Test.",
      "oauth2": "Pengambilan token OAuth2 telah disambung di pihak admin; pengambil runtime menyusul kemudian. Buat masa ini, isi nilai dan jalankan Test untuk mengesahkan baki konfigurasi.",
      "tls": "Tampal root CA untuk menyemat sijil pelayan rakan, atau tampal client cert + key untuk mTLS. CA sahaja berfungsi dengan stor root sistem untuk CA yang terkenal."
    },
    "option": {
      "method": {
        "none": "Tiada",
        "basic": "HTTP Basic",
        "bearer": "Bearer token",
        "oauth2": "OAuth2 client_credentials",
        "clientCert": "Client certificate (mTLS)"
      }
    },
    "tlsLabel": {
      "ca": "Server CA (PEM) — pilihan untuk kebanyakan rakan",
      "clientCertRequired": "Client certificate (PEM) — diperlukan",
      "clientCertMtls": "Client certificate (PEM) — untuk mTLS",
      "clientKeyRequired": "Client private key (PEM) — diperlukan",
      "clientKeyOptional": "Client private key (PEM)"
    },
    "validation": {
      "nameRequired": "Nama diperlukan",
      "baseUrlRequired": "Base URL diperlukan",
      "baseUrlInvalid": "URL asas mestilah URL http(s) yang sah",
      "basicUsername": "Basic auth memerlukan nama pengguna",
      "basicPassword": "Basic auth memerlukan kata laluan",
      "bearerToken": "Bearer auth memerlukan token",
      "clientCertKey": "Pengesahan Client-certificate memerlukan cert + key"
    }
  },
  "smartApp": {
    "titleEdit": "Edit Aplikasi SMART",
    "titleRegister": "Daftar Aplikasi SMART",
    "subtitle": "Pendaftaran klien SMART on FHIR. Client ID dijana automatik untuk anda; client secret dipaparkan sekali sahaja selepas penciptaan atau penggiliran.",
    "back": "Kembali",
    "cancel": "Batal",
    "save": "Simpan Perubahan",
    "register": "Daftar",
    "fields": {
      "appName": "Nama Aplikasi",
      "redirectUris": "URI Ubah Hala",
      "scopes": "Skop (scope)",
      "launchUrl": "URL Pelancaran",
      "logoUrl": "URL Logo",
      "active": "Aktif — nyahtanda untuk membatalkan lembut aplikasi ini."
    },
    "placeholder": {
      "appName": "Pelancar EHR Saya"
    },
    "helper": {
      "redirectUris": "Satu URI setiap baris. https:// diperlukan (http://localhost juga diterima untuk pembangunan)."
    },
    "secretModal": {
      "title": "Simpan client secret ini sekarang",
      "body": "Secret ini dipaparkan sekali sahaja. Jika hilang, gilirkan secret untuk mengeluarkan yang baharu.",
      "clientId": "Client ID",
      "clientSecret": "Client Secret",
      "copyClientId": "Salin Client ID",
      "copyClientSecret": "Salin Client Secret",
      "saved": "Saya telah menyimpannya"
    },
    "validation": {
      "nameRequired": "Nama diperlukan",
      "redirectUriRequired": "Sekurang-kurangnya satu URI ubah hala diperlukan",
      "scopeRequired": "Sekurang-kurangnya satu skop (scope) diperlukan"
    }
  },
  "interfaceLog": {
    "list": {
      "title": "Log Mesej Antara Muka",
      "subtitle": "Mesej HL7 masuk + keluar merentas setiap integrasi aktif.",
      "refresh": "Segar Semula",
      "loading": "Memuatkan mesej…",
      "empty": "Tiada mesej sepadan dengan penapis semasa.",
      "pagination": "{{total}} mesej • halaman {{page}} daripada {{pages}}",
      "prev": "Sebelum",
      "next": "Seterusnya",
      "archived": "(arkib)"
    },
    "relative": {
      "secondsAgo": "{{n}}s lalu",
      "minutesAgo": "{{n}}m lalu",
      "hoursAgo": "{{n}}j lalu"
    },
    "filter": {
      "header": "Penapis",
      "direction": "Arah",
      "status": "Status",
      "messageType": "Jenis mesej",
      "msh10": "MSH-10 mengandungi",
      "integrationId": "ID Integrasi",
      "includeArchive": "Sertakan arkib",
      "clear": "Kosongkan penapis",
      "any": "Mana-mana",
      "messageTypePlaceholder": "cth. ADT^A01",
      "controlIdPlaceholder": "id kawalan"
    },
    "columns": {
      "id": "ID",
      "dir": "Arah",
      "integ": "Integ",
      "type": "Jenis",
      "msh10": "MSH-10",
      "status": "Status",
      "ack": "ACK",
      "attempts": "Cubaan",
      "when": "Bila"
    },
    "detail": {
      "eyebrow": "Mesej {{direction}}",
      "close": "Tutup",
      "loading": "Memuatkan…",
      "tabs": {
        "overview": "Gambaran keseluruhan",
        "rawHl7": "HL7 mentah",
        "attempts": "Percubaan"
      },
      "operatorActions": "Tindakan operator",
      "retry": "Cuba semula",
      "skip": "Langkau",
      "abandon": "Tinggalkan",
      "resendAsNew": "Hantar semula sebagai baharu",
      "skipReason": "Sebab langkau",
      "abandonReason": "Sebab tinggalkan",
      "actionsHelper": "Tindakan diaudit dengan ID pengguna + sebab anda. Langkau + Tinggalkan memerlukan sebab.",
      "overview": {
        "direction": "Arah",
        "integration": "Integrasi",
        "type": "Jenis",
        "msh10": "MSH-10",
        "status": "Status",
        "ackCode": "Kod ACK",
        "attempts": "Percubaan",
        "created": "Dicipta",
        "ackReceived": "ACK diterima",
        "nextRetry": "Percubaan seterusnya",
        "ackText": "Teks ACK",
        "lastError": "Ralat terakhir",
        "sourceEventId": "ID peristiwa sumber"
      },
      "rawViewer": {
        "permissionDenied": "HL7 mentah yang dinyahsulit memerlukan kebenaran <code>INTERFACE_OPERATE</code>.",
        "notAvailable": "Payload mentah tidak tersedia untuk mesej ini.",
        "bytes": "{{bytes}} bait",
        "copy": "Salin"
      },
      "attempts": {
        "inboundInfo": "Sejarah percubaan dijejak untuk mesej keluar sahaja. Mesej masuk diproses sekali setiap MSH-10; penghantaran semula mengembalikan ACK yang dicache tanpa percubaan baharu.",
        "totalAttempts": "Jumlah percubaan",
        "nextAt": " (seterusnya pada {{time}})",
        "refresh": "Segar semula",
        "loading": "Memuatkan percubaan…",
        "error": "Gagal memuatkan percubaan.",
        "empty": "Belum ada percubaan direkodkan. Pekerja menulis satu baris setiap penghantaran; senarai ini diisi selepas tuntutan pertama.",
        "columns": {
          "when": "Bila",
          "outcome": "Keputusan",
          "ack": "ACK",
          "duration": "Tempoh",
          "detail": "Butiran"
        }
      }
    }
  },
  "thirdPartyApp": {
    "list": {
      "title": "Aplikasi Pihak Ketiga",
      "subtitle": "Konfigurasikan aplikasi luaran yang boleh dilancarkan daripada VynaEMR dengan konteks pesakit",
      "addApp": "Tambah Aplikasi",
      "searchPlaceholder": "Cari aplikasi mengikut nama, kod atau kategori...",
      "emptyTitle": "Tiada aplikasi dikonfigurasikan",
      "emptyBody": "Tambah aplikasi luaran seperti pemapar PACS, portal makmal atau sistem farmasi.",
      "columns": {
        "application": "Aplikasi",
        "category": "Kategori",
        "url": "URL",
        "security": "Keselamatan",
        "display": "Paparan",
        "status": "Status",
        "actions": "Tindakan"
      }
    },
    "badge": {
      "jwt": "JWT",
      "jwtSigned": "Ditandatangani JWT",
      "hmac": "HMAC",
      "hmacSigned": "Ditandatangani HMAC",
      "none": "Tiada",
      "chart": "Carta",
      "sidebar": "Bar sisi",
      "active": "Aktif",
      "inactive": "Tidak aktif"
    },
    "action": {
      "testLaunch": "Uji Lancar",
      "edit": "Edit",
      "deactivate": "Nyahaktifkan"
    },
    "form": {
      "titleEdit": "Edit Aplikasi",
      "titleNew": "Aplikasi Baharu",
      "fields": {
        "appCode": "Kod Aplikasi",
        "appName": "Nama Aplikasi",
        "category": "Kategori",
        "baseUrl": "URL Asas",
        "launchMethod": "Kaedah Pelancaran",
        "paramMappings": "Pemetaan Parameter",
        "enableJwt": "Dayakan Penandatanganan Token JWT",
        "sharedSecret": "Rahsia Dikongsi (kunci penandatanganan JWT)",
        "enableHmac": "Dayakan Tandatangan URL (HMAC)",
        "hmacKey": "Kunci HMAC",
        "requiredPermission": "Kebenaran Diperlukan",
        "displayOrder": "Susunan Paparan",
        "showInChart": "Tunjukkan dalam Carta",
        "showInSidebar": "Tunjukkan dalam Bar Sisi"
      },
      "placeholder": {
        "appCode": "cth. pacs_viewer",
        "appName": "cth. PACS Viewer",
        "baseUrl": "https://pacs.hospital.com/viewer",
        "paramName": "Nama param URL",
        "unchanged": "(tidak berubah)",
        "sharedSecret": "Masukkan rahsia dikongsi",
        "hmacKey": "Masukkan kunci HMAC",
        "requiredPermission": "cth. RESULT_VIEW (kosong = mana-mana pengguna)"
      },
      "addParameter": "Tambah Parameter",
      "cancel": "Batal",
      "submitUpdate": "Kemas Kini Aplikasi",
      "submitCreate": "Cipta Aplikasi"
    },
    "paramSource": {
      "patientMrn": "MRN Pesakit",
      "patientName": "Nama Pesakit",
      "patientDob": "DOB Pesakit",
      "encounterId": "ID Pertemuan",
      "encounterNumber": "Nombor Pertemuan",
      "orderNumber": "Nombor Pesanan",
      "userName": "Nama Pengguna Semasa",
      "userId": "ID Pengguna Semasa",
      "timestamp": "Cap Masa Semasa"
    },
    "launch": "Lancarkan {{name}}"
  },
  "integrationForm": {
    "titleEdit": "Edit Integrasi",
    "titleAdd": "Tambah Integrasi",
    "subtitle": "Antara muka MLLP dan HL7-over-HTTP yang disokong oleh VynaHL7. Bahan sijil disimpan pada baris integrasi; putaran berkuat kuasa pada kali berikutnya pelayan atau klien dimulakan semula.",
    "back": "Kembali",
    "cancel": "Batal",
    "saveChanges": "Simpan Perubahan",
    "addIntegration": "Tambah Integrasi",
    "storedBlank": "Disimpan — biarkan kosong untuk kekal",
    "selectSibling": "— pilih integrasi setaraf —",
    "section": {
      "basics": "Asas",
      "connection": "Sambungan",
      "tls": "TLS / mTLS",
      "auth": "Pengesahan",
      "ackDelivery": "Pengakuan & Penghantaran",
      "outboundRouting": "Penghalaan keluar",
      "inboundTrust": "Kepercayaan masuk"
    },
    "fields": {
      "name": "Nama",
      "type": "Jenis",
      "direction": "Arah",
      "description": "Penerangan",
      "active": "Aktif — nyahtanda untuk melumpuhkan lembut antara muka ini.",
      "host": "Hos",
      "port": "Port",
      "enableTls": "Dayakan TLS — menggunakan",
      "serverCert": "Sijil pelayan (PEM)",
      "clientCert": "Sijil klien (PEM) — pilihan untuk mTLS",
      "serverKey": "Kunci peribadi pelayan (PEM)",
      "clientKey": "Kunci peribadi klien (PEM)",
      "serverCa": "Stor amanah CA klien (PEM) — untuk mTLS",
      "clientCa": "Stor amanah CA pelayan (PEM) — pilihan, kembali ke root sistem",
      "method": "Kaedah",
      "username": "Nama pengguna",
      "password": "Kata laluan",
      "bearerToken": "Token Bearer",
      "inboundAck": "Dasar ACK masuk",
      "outboundAck": "Dasar ACK keluar",
      "processingTimeout": "Tamat masa pemprosesan (ms)",
      "pendingAckTtl": "TTL ACK tertangguh (saat)",
      "networkRetry": "Maks cuba semula rangkaian",
      "appNakRetry": "Maks cuba semula NAK apl",
      "reverseIntegration": "Integrasi saluran songsang",
      "outboundTypes": "Jenis mesej yang diterima",
      "outboundEvents": "Langganan peringkat peristiwa",
      "receivingApplication": "Aplikasi penerima (MSH-5)",
      "receivingFacility": "Fasiliti penerima (MSH-6)",
      "inboundTrustProfile": "Rakan kongsi ini boleh"
    },
    "placeholder": {
      "name": "Hospital LIS ADT",
      "description": "Nota ringkas tentang antara muka ini — pemilik, tujuan, jenis mesej, dll.",
      "hostServer": "0.0.0.0",
      "hostClient": "lis.hospital.local",
      "portMllp": "2575",
      "portOther": "443",
      "username": "svc-vynaemr",
      "outboundEvents": "ADT^A01, SIU^S12",
      "receivingApplication": "LAB_A",
      "receivingFacility": "CENTRAL_LAB"
    },
    "helper": {
      "hostServer": "Alamat ikat. Gunakan 0.0.0.0 untuk mendengar pada semua antara muka.",
      "hostClient": "Hos jauh yang patut dihubungi oleh klien ini.",
      "tlsHandshake": "untuk jabat tangan.",
      "authClientCert": "Sijil/kunci klien datang dari bahagian TLS di atas.",
      "authNone": "Tiada pengepala pengesahan HTTP dilampirkan.",
      "authRs7": "{{call}} menyambungkan ini ke setiap permintaan keluar.",
      "ackDefaults": "Mengawal cara get laluan meng-ACK mesej HL7 masuk dan cara menafsirkan ACK respons pada penghantaran keluar. Nilai lalai",
      "ackDefaultsTail": "sepadan dengan tingkah laku pra-0.19.0 — ubah mengikut rakan kongsi seperti yang diperlukan.",
      "processingTimeout": "Had untuk pemprosesan sebaris ACK apl segerak. Tamat masa → AE + cuba semula baris gilir latar belakang.",
      "pendingAckTtl": "Masa menunggu ACK apl mod dipertingkat sebelum penyapu menamatkan masanya.",
      "networkRetry": "Cuba semula bagi ralat pengangkutan sebelum baris gilir disekat.",
      "appNakRetry": "Cuba semula bagi AE/AR/CE/CR — biasanya 2–3 kerana muatan yang sama jarang berjaya apabila dicuba semula.",
      "reverse": "Mod dipertingkat menghantar ACK apl sebenar melalui integrasi setaraf yang menghala ke titik akhir songsang rakan kongsi. Cipta integrasi setaraf sebagai baris berasingan dahulu, kemudian pautkan di sini.",
      "outboundRouting": "Apa yang diterima rakan ini. Jika tiada yang dipilih, integrasi ini bukan destinasi keluar dan tiada mesej dihantar kepadanya.",
      "outboundEvents": "Pilihan, dipisahkan koma. Lebih khusus daripada satu jenis penuh — untuk rakan yang mahukan peristiwa tertentu sahaja.",
      "receivingDefaults": "MSH-5 dan MSH-6 menamakan penerima pada setiap mesej yang dihantar ke sini. Biarkan kosong untuk menggunakan nama antara muka.",
      "inboundTrust": "Apa yang rakan kongsi ini boleh nyatakan tentang identiti pesakit. Pengesahan menyatakan siapa yang menyambung; tetapan ini menyatakan apa yang mereka dibenarkan beritahu kami. Kekalkan lalai penggunaan melainkan peer ini benar-benar sistem induk pendaftaran."
    },
    "option": {
      "type": {
        "mllp": "MLLP (HL7 v2 melalui TCP)",
        "hoh": "HoH (HL7 melalui HTTPS)",
        "fhir": "FHIR R4"
      },
      "direction": {
        "client": "Klien (keluar)",
        "server": "Pelayan (masuk)"
      },
      "method": {
        "none": "Tiada",
        "basic": "HTTP Basic",
        "bearer": "Token Bearer",
        "clientCert": "Sijil klien (mTLS)"
      }
    },
    "ack": {
      "inbound": {
        "acceptOnly": "AA serta-merta (lalai semasa)",
        "honorMsh16": "baca MSH-15/16 setiap mesej",
        "forceSync": "proses sebaris, AA/AE/AR mengikut hasil",
        "forceEnhanced": "CA sekarang + ACK apl melalui saluran songsang"
      },
      "outbound": {
        "fireAndForget": "hantar dan lupakan (lalai semasa)",
        "expectSync": "tetapkan MSH-16=AL, cuba semula pada AE/AR",
        "expectEnhanced": "tunggu CA + ACK apl susulan"
      }
    },
    "validation": {
      "nameRequired": "Nama diperlukan",
      "hostRequired": "Hos diperlukan",
      "mllpPort": "Integrasi MLLP memerlukan port",
      "portNumber": "Port mestilah nombor",
      "tlsServerCertKey": "Pelayan TLS memerlukan kedua-dua sijil dan kunci",
      "basicUsername": "Pengesahan Basic memerlukan nama pengguna",
      "basicPassword": "Pengesahan Basic memerlukan kata laluan",
      "bearerToken": "Pengesahan Bearer memerlukan token",
      "enhancedReverse": "Mod ACK dipertingkat memerlukan integrasi songsang — pilih satu di bawah.",
      "outboundEvent": "\"{{value}}\" bukan mesej yang dihantar oleh sistem ini — gunakan jenis seperti ADT, atau peristiwa seperti ADT^A01."
    },
    "trust": {
      "useDeploymentDefault": "Guna lalai penggunaan",
      "observer": "Pemerhati — tidak pernah mencipta atau mengubah pesakit",
      "demographics": "Demografi — boleh membetulkan pesakit sedia ada, termasuk notis kematian; tidak mencipta",
      "registration": "Pendaftaran — boleh juga mencipta pesakit dan menggabungkan rekod"
    },
    "__review_inboundTrust": "Machine-authored — needs native review"
  },
  "thirdPartyAppCategory": {
    "imaging": "Pengimejan",
    "laboratory": "Makmal",
    "pharmacy": "Farmasi",
    "specialty": "Kepakaran",
    "portal": "Portal",
    "billing": "Pengebilan",
    "other": "Lain-lain"
  },
  "thirdPartyLaunchMethod": {
    "redirect": "Lencongan",
    "popup": "Tetingkap Popup",
    "iframe": "iframe",
    "newTab": "Tab Baharu"
  },
  "cdsRule": {
    "form": {
      "titleEdit": "Edit Peraturan CDS",
      "titleCreate": "Cipta Peraturan CDS",
      "ruleName": "Nama Peraturan",
      "ruleType": "Jenis Peraturan",
      "selectPlaceholder": "Pilih…",
      "severity": "Tahap Keterukan",
      "triggerEvent": "Peristiwa Pencetus",
      "actionType": "Jenis Tindakan",
      "description": "Penerangan",
      "active": "Aktif",
      "cancel": "Batal",
      "submitUpdate": "Kemas Kini Peraturan",
      "submitCreate": "Cipta Peraturan",
      "createdOk": "Peraturan berjaya dicipta",
      "createFailed": "Gagal mencipta peraturan",
      "updatedOk": "Peraturan berjaya dikemas kini",
      "updateFailed": "Gagal mengemas kini peraturan",
      "validation": {
        "nameRequired": "Nama peraturan diperlukan",
        "typeRequired": "Jenis peraturan diperlukan",
        "descriptionRequired": "Penerangan diperlukan",
        "triggerRequired": "Peristiwa pencetus diperlukan",
        "actionRequired": "Jenis tindakan diperlukan"
      }
    },
    "list": {
      "title": "Peraturan CDS",
      "subtitle": "Urus peraturan sokongan keputusan klinikal",
      "addRule": "Tambah Peraturan",
      "loading": "Memuatkan peraturan CDS…",
      "loadError": "Gagal memuatkan peraturan CDS.",
      "empty": "Tiada peraturan CDS dikonfigurasikan.",
      "columns": {
        "ruleName": "Nama Peraturan",
        "type": "Jenis",
        "severity": "Tahap Keterukan",
        "description": "Penerangan",
        "status": "Status",
        "actions": "Tindakan"
      },
      "toggleActive": "Klik untuk menyahaktifkan",
      "toggleInactive": "Klik untuk mengaktifkan",
      "active": "Aktif",
      "inactive": "Tidak Aktif",
      "editRule": "Edit peraturan",
      "statusUpdated": "Status peraturan dikemas kini",
      "statusUpdateFailed": "Gagal mengemas kini status peraturan"
    }
  },
  "cdsSeverity": {
    "info": "Maklumat",
    "warning": "Amaran",
    "critical": "Kritikal"
  },
  "cdsTriggerEvent": {
    "orderSign": "Tandatangan Pesanan",
    "orderSelect": "Pilih Pesanan",
    "patientView": "Lihat Pesakit",
    "medicationPrescribe": "Preskripsi Ubat",
    "resultReceived": "Keputusan Diterima",
    "patientAdmit": "Kemasukan Pesakit"
  },
  "cdsActionType": {
    "alert": "Amaran",
    "warning": "Peringatan",
    "hardStop": "Hentian Paksa",
    "suggestion": "Cadangan",
    "notification": "Pemberitahuan"
  },
  "cdsRuleType": {
    "drugInteraction": "Interaksi Ubat",
    "drugAllergy": "Alahan Ubat",
    "duplicateOrder": "Pesanan Pendua",
    "custom": "Tersuai",
    "clinicalAlert": "Amaran Klinikal",
    "sepsisScreen": "Saringan Sepsis"
  },
  "system": {
    "title": "Konfigurasi Sistem",
    "subtitle": "Tetapan aplikasi, keselamatan, dan kesihatan sistem",
    "restartServices": "Mulakan Semula Perkhidmatan",
    "restartToast": "Mulakan semula perkhidmatan (pemegang tempat - memerlukan pengesahan)",
    "loadError": "Gagal memuatkan Konfigurasi Sistem",
    "section": {
      "systemInfo": "Maklumat Sistem",
      "systemInfoDesc": "Versi, masa beroperasi, dan kesihatan perkhidmatan",
      "general": "Tetapan Umum",
      "generalDesc": "Nama aplikasi, zon waktu, dan penjenamaan",
      "security": "Tetapan Keselamatan",
      "securityDesc": "Dasar kata laluan, MFA, dan pengurusan sesi",
      "notifications": "Tetapan Pemberitahuan",
      "notificationsDesc": "Konfigurasi get laluan e-mel dan SMS",
      "integration": "Lalai Penyepaduan",
      "integrationDesc": "Konfigurasi lalai MLLP, FHIR, dan HL7",
      "featureFlags": "Bendera Ciri",
      "featureFlagsDesc": "Dayakan atau lumpuhkan ciri sistem",
      "patientAccess": "Patient Access",
      "patientAccessDesc": "Default patient visibility scope"
    },
    "info": {
      "version": "Versi",
      "uptime": "Masa Beroperasi",
      "database": "Pangkalan Data",
      "redis": "Redis",
      "microservices": "Perkhidmatan Mikro",
      "conn": "sambungan"
    },
    "uptime": {
      "running": "Berjalan",
      "unknown": "Tidak Diketahui",
      "up": "Aktif"
    },
    "subsection": {
      "passwordPolicy": "Dasar Kata Laluan",
      "mfa": "Pengesahan Berbilang Faktor",
      "sessionLockout": "Sesi & Kunci",
      "emailConfig": "Konfigurasi E-mel",
      "smsGateway": "Get Laluan SMS",
      "mllpDefaults": "Lalai MLLP",
      "fhirConfig": "Konfigurasi FHIR",
      "hl7Encoding": "Pengekodan HL7 v2"
    },
    "fields": {
      "appName": "Nama Aplikasi",
      "timezone": "Zon Waktu",
      "dateFormat": "Format Tarikh",
      "supportEmail": "E-mel Sokongan",
      "logoUrl": "URL Logo",
      "maintenanceMode": "Mod Penyelenggaraan (lumpuhkan akses pengguna)",
      "upload": "Muat Naik",
      "minPasswordLength": "Panjang Kata Laluan Minimum",
      "passwordExpiry": "Tamat Tempoh Kata Laluan (hari)",
      "requireUppercase": "Perlukan huruf besar",
      "requireNumbers": "Perlukan nombor",
      "requireSpecialChars": "Perlukan aksara khas",
      "enableMfa": "Dayakan MFA",
      "mfaMethod": "Kaedah MFA",
      "sessionTimeout": "Tamat Masa Sesi (minit)",
      "maxLoginAttempts": "Maks Cubaan Log Masuk",
      "lockoutDuration": "Tempoh Kunci (minit)",
      "smtpHost": "Hos SMTP",
      "smtpPort": "Port SMTP",
      "smtpUser": "Pengguna SMTP",
      "fromEmail": "E-mel Penghantar",
      "useTls": "Guna TLS",
      "enabled": "Didayakan",
      "provider": "Pembekal",
      "fromNumber": "Nombor Penghantar",
      "defaultPort": "Port Lalai",
      "timeoutSeconds": "Tamat Masa (saat)",
      "retryCount": "Bilangan Cuba Semula",
      "fhirBaseUrl": "FHIR Base URL",
      "authMethod": "Kaedah Pengesahan",
      "fieldSeparator": "Pemisah Medan",
      "encodingChars": "Aksara Pengekodan",
      "visibilityScope": "Visibility scope",
      "visibilityScopeDesc": "Who can see a patient by default. Facilities may override this; the stricter side always wins. Takes effect immediately."
    },
    "option": {
      "tz": {
        "singapore": "Asia/Singapura (UTC+8)",
        "hongKong": "Asia/Hong Kong (UTC+8)",
        "kualaLumpur": "Asia/Kuala Lumpur (UTC+8)",
        "bangkok": "Asia/Bangkok (UTC+7)",
        "tokyo": "Asia/Tokyo (UTC+9)",
        "kolkata": "Asia/Kolkata (UTC+5:30)",
        "sydney": "Australia/Sydney (UTC+11)"
      },
      "mfa": {
        "totp": "TOTP (Aplikasi Pengesah)",
        "sms": "SMS",
        "email": "E-mel"
      },
      "fhirAuth": {
        "none": "Tiada",
        "oauth2": "OAuth 2.0",
        "basic": "Basic Auth"
      },
      "visibility": {
        "organization": "Organization - shared health system",
        "facility": "Facility - shared facility (default)",
        "department": "Department - shared encounter department"
      }
    },
    "save": {
      "general": "Simpan Tetapan Umum",
      "security": "Simpan Tetapan Keselamatan",
      "notifications": "Simpan Tetapan Pemberitahuan",
      "integration": "Simpan Penyepaduan",
      "features": "Simpan Bendera Ciri",
      "patientaccess": "Save Patient Access"
    },
    "sectionName": {
      "general": "Umum",
      "security": "Keselamatan",
      "notifications": "Pemberitahuan",
      "integration": "Penyepaduan",
      "features": "Bendera Ciri",
      "patientaccess": "Patient Access"
    },
    "toast": {
      "uploadPlaceholder": "Muat naik logo (pemegang tempat)",
      "saved": "Tetapan {{section}} berjaya disimpan",
      "saveFailed": "Gagal menyimpan tetapan"
    },
    "featureFlag": {
      "patientMerge": {
        "label": "Gabungan Pesakit",
        "description": "Dayakan fungsi gabung/nyahgabung pesakit"
      },
      "breakGlass": {
        "label": "Akses Kecemasan",
        "description": "Benarkan penggantian kecemasan untuk rekod terhad"
      },
      "fhirApi": {
        "label": "FHIR R4 API",
        "description": "Dedahkan endpoint FHIR R4 untuk sistem luaran"
      },
      "smartApps": {
        "label": "Aplikasi SMART on FHIR",
        "description": "Benarkan aplikasi SMART pihak ketiga menyambung"
      },
      "clinicalDecisionSupport": {
        "label": "Sokongan Keputusan Klinikal",
        "description": "Dayakan CDS hooks untuk kemasukan pesanan"
      },
      "telemedicine": {
        "label": "Modul Teleperubatan",
        "description": "Perundingan video dan pemantauan jarak jauh"
      },
      "patientPortal": {
        "label": "Portal Pesakit",
        "description": "Portal untuk pesakit melihat rekod dan temu janji"
      },
      "analyticsDashboard": {
        "label": "Papan Pemuka Analitik",
        "description": "Papan pemuka analitik dan pelaporan lanjutan"
      },
      "medicationBarcode": {
        "label": "Imbasan Kod Bar Ubat",
        "description": "Pengesahan kod bar untuk pentadbiran ubat"
      },
      "autoCoding": {
        "label": "Pengekodan Auto (ICD/CPT)",
        "description": "Pengekodan diagnosis dan prosedur dibantu AI"
      }
    }
  },
  "audit": {
    "title": "Log Audit",
    "subtitle": "Log aktiviti sistem dengan penjejakan perubahan terperinci",
    "exportCsv": "Eksport CSV",
    "exportToast": "Mengeksport {{count}} entri audit sebagai CSV (penanda tempat)",
    "searchPlaceholder": "Cari mengikut pengguna…",
    "advanced": "Lanjutan",
    "breakGlassOnly": "Akses Kecemasan sahaja",
    "fromTo": "Dari / Hingga:",
    "fromDate": "Tarikh mula",
    "toDate": "Tarikh tamat",
    "clearFilters": "Kosongkan semua penapis",
    "entriesFound": "{{count}} entri dijumpai",
    "noMatch": "Tiada entri audit sepadan dengan penapis anda",
    "viewDetails": "Lihat butiran",
    "detail": {
      "title": "Butiran Entri Audit",
      "timestamp": "Cap masa",
      "user": "Pengguna",
      "action": "Tindakan",
      "resource": "Sumber",
      "ipAddress": "Alamat IP",
      "breakGlass": "Akses Kecemasan",
      "yes": "Ya",
      "no": "Tidak",
      "details": "Butiran",
      "dataChanges": "Perubahan Data",
      "before": "Sebelum",
      "after": "Selepas",
      "result": "Keputusan"
    },
    "columns": {
      "timestamp": "Cap masa",
      "user": "Pengguna",
      "action": "Tindakan",
      "resource": "Sumber",
      "resourceId": "ID Sumber",
      "ipAddress": "Alamat IP",
      "details": "Butiran",
      "view": "Lihat"
    },
    "filter": {
      "action": {
        "all": "Semua Tindakan",
        "create": "Cipta",
        "read": "Baca",
        "update": "Kemas kini",
        "delete": "Padam",
        "login": "Log masuk",
        "logout": "Log keluar",
        "export": "Eksport",
        "breakGlass": "Akses Kecemasan"
      },
      "resource": {
        "all": "Semua Sumber",
        "patient": "Pesakit",
        "encounter": "Pertemuan",
        "order": "Pesanan",
        "result": "Keputusan",
        "medication": "Ubat",
        "user": "Pengguna",
        "system": "Sistem"
      }
    },
    "pagination": {
      "first": "Pertama",
      "last": "Terakhir",
      "pageOf": "Halaman {{page}} daripada {{pages}}",
      "range": "{{from}}-{{to}} daripada {{total}}"
    }
  },
  "taxonomy": {
    "title": "Taksonomi Klinikal",
    "subtitle": "Barisan perkhidmatan mengumpulkan perkhidmatan klinikal berkaitan (Cardiovascular → Cardiology, EP Lab, Heart Failure Clinic). Kedua-duanya menyuap matriks penetapan perkhidmatan ↔ lokasi yang digunakan untuk penjadualan.",
    "addServiceLine": "Tambah Barisan Perkhidmatan",
    "addClinicalService": "Tambah Perkhidmatan Klinikal",
    "tabs": {
      "serviceLines": "Barisan Perkhidmatan",
      "clinicalServices": "Perkhidmatan Klinikal"
    },
    "searchLines": "Cari barisan perkhidmatan...",
    "searchServices": "Cari perkhidmatan klinikal...",
    "empty": {
      "linesNone": "Tiada barisan perkhidmatan dikonfigurasi.",
      "linesNoMatch": "Tiada barisan perkhidmatan sepadan.",
      "servicesNone": "Tiada perkhidmatan klinikal dikonfigurasi.",
      "servicesNoMatch": "Tiada perkhidmatan klinikal sepadan."
    },
    "columns": {
      "name": "Nama",
      "code": "Kod",
      "description": "Penerangan",
      "services": "Perkhidmatan",
      "status": "Status",
      "serviceLine": "Barisan Perkhidmatan",
      "specialty": "Pakar Bidang",
      "actions": "Tindakan"
    },
    "status": {
      "active": "Aktif",
      "inactive": "Tidak Aktif"
    },
    "editTitle": "Edit"
  },
  "systemStatus": {
    "connected": "Disambungkan",
    "error": "Ralat"
  },
  "escalation": {
    "title": "Escalation Rules",
    "subtitle": "Configure how an unacknowledged critical result is re-paged",
    "help": "An escalation rule is the re-paging ladder for a trigger event. A level fires when the ORIGINAL page is older than its delay (in minutes) and the result is still unacknowledged; every user holding the listed roles at the encounter's facility is then paged. Only the critical_result trigger is wired to a consumer today, so rules can be edited but not created.",
    "loadError": "Failed to load escalation rules.",
    "empty": "No escalation rules configured.",
    "active": "Active",
    "inactive": "Inactive",
    "selectPrompt": "Select a rule to edit its ladder.",
    "list": {
      "header": "Rules",
      "levelCount": "{{n}} levels"
    },
    "editor": {
      "ruleName": "Rule Name",
      "triggerEvent": "Trigger Event",
      "initialRecipient": "Initial page goes to: {{role}}",
      "active": "Active",
      "ladder": "Escalation Ladder",
      "level": "Level",
      "delayMinutes": "Delay (minutes)",
      "roles": "Roles Paged",
      "addRole": "Add a role...",
      "noRoles": "No roles selected — this level will be rejected.",
      "noLevels": "This rule has no levels. Add at least one.",
      "addLevel": "Add Level",
      "removeLevel": "Remove level {{level}}",
      "removeRole": "Remove role {{role}}",
      "reset": "Reset",
      "save": "Save Rule",
      "holderCount": "{{count}} petugas",
      "unstaffedBadge": "tiada petugas",
      "unstaffedWarning": "Peranan berikut tiada petugas, jadi tahap tersebut tidak akan memanggil sesiapa: {{roles}}. Tetapkan peranan kepada kakitangan di Admin → Pengguna."
    },
    "validation": {
      "nameRequired": "Rule name is required.",
      "ladderRequired": "The ladder must have at least one level.",
      "levelInvalid": "Every level number must be 1 or greater.",
      "levelDuplicate": "Level numbers must be unique.",
      "delayInvalid": "Level {{level}}: the delay must be a whole number of minutes, 0 or greater.",
      "rolesRequired": "Level {{level}}: select at least one role.",
      "unknownRole": "Unknown role: {{role}}."
    },
    "toast": {
      "saved": "Escalation rule saved",
      "saveFailed": "Failed to save escalation rule",
      "invalidLadder": "The escalation ladder was rejected: check the level numbers, delays and roles.",
      "notFound": "Escalation rule not found",
      "forbidden": "You do not have permission to edit escalation rules"
    }
  },
  "review": {
    "list": {
      "title": "Access Reviews",
      "empty": "No review campaigns yet. Open one to snapshot every live grant for certification.",
      "columns": {
        "name": "Campaign",
        "status": "Status",
        "dueDate": "Due",
        "progress": "Progress",
        "created": "Opened",
        "actions": "Actions"
      },
      "status": {
        "open": "Open",
        "closed": "Closed"
      },
      "progress": "{{pending}} of {{total}} pending",
      "create": {
        "namePlaceholder": "Campaign name (blank = dated default)",
        "dueLabel": "Due",
        "submit": "Open campaign"
      }
    },
    "detail": {
      "back": "All reviews",
      "columns": {
        "user": "User",
        "role": "Role",
        "facility": "Facility",
        "window": "Grant window",
        "grantedBy": "Granted by",
        "state": "Grant",
        "decision": "Decision",
        "decidedBy": "Decided by",
        "actions": "Actions"
      },
      "certify": "Certify",
      "revoke": "Revoke",
      "live": "live",
      "dead": "lapsed",
      "permanent": "permanent",
      "allFacilities": "All facilities",
      "close": "Close campaign",
      "delete": "Delete",
      "filter": {
        "label": "Show",
        "all": "All",
        "pending": "Pending",
        "decided": "Decided"
      },
      "decision": {
        "pending": "Pending",
        "certified": "Certified",
        "revoked": "Revoked"
      },
      "closeBlocked": "{{count}} item(s) still pending",
      "empty": "No grants were live when this campaign opened.",
      "confirmRevoke": {
        "title": "Revoke this grant?",
        "description": "The role grant is deleted for real — the user loses it immediately. This cannot be undone from the review.",
        "confirm": "Revoke grant"
      },
      "confirmClose": {
        "title": "Close this campaign?",
        "description": "Closed campaigns are the attestation record: items can no longer be decided and the campaign cannot be deleted.",
        "confirm": "Close campaign"
      },
      "confirmDelete": {
        "title": "Delete this campaign?",
        "description": "The open campaign and its undecided items are discarded. Only open campaigns can be deleted.",
        "confirm": "Delete campaign"
      }
    },
    "toast": {
      "created": "Review campaign opened",
      "createError": "Failed to open review campaign",
      "certified": "Grant certified",
      "revoked": "Grant revoked",
      "closed": "Review campaign closed",
      "deleted": "Review campaign deleted",
      "saveError": "Failed to save the decision"
    }
  },
  "sso": {
    "title": "Single sign-on",
    "subtitle": "Identity providers, email domains, and LDAP directories",
    "status": {
      "enabled": "Enabled",
      "disabled": "Disabled"
    },
    "tabs": {
      "providers": "Providers",
      "directories": "Directories",
      "domains": "Domains",
      "scim": "SCIM provisioning"
    },
    "providers": {
      "new": "New provider",
      "edit": "Edit provider",
      "delete": "Delete provider",
      "empty": "No identity providers yet.",
      "columns": {
        "name": "Name",
        "system": "Health system",
        "kind": "Kind",
        "issuer": "Issuer",
        "status": "Status",
        "users": "Users",
        "actions": "Actions"
      },
      "toast": {
        "deletedKept": "Provider deleted. {{count}} logins kept.",
        "deleted": "Provider deleted.",
        "deleteFailed": "Could not delete the provider."
      },
      "deleteConfirm": {
        "title": "Delete {{name}}?",
        "description": "Provisioned logins survive ({{count}}), unlinked. In-flight sign-in states and group mappings go with the provider.",
        "confirm": "Delete"
      }
    },
    "directories": {
      "new": "New directory",
      "edit": "Edit directory",
      "delete": "Delete directory",
      "empty": "No LDAP directories yet.",
      "columns": {
        "name": "Name",
        "system": "Health system",
        "host": "Host",
        "tls": "TLS",
        "status": "Status",
        "users": "Users",
        "actions": "Actions"
      },
      "toast": {
        "deletedKept": "Directory deleted. {{count}} logins kept.",
        "deleted": "Directory deleted.",
        "deleteFailed": "Could not delete the directory."
      },
      "deleteConfirm": {
        "title": "Delete {{name}}?",
        "description": "Provisioned logins survive ({{count}}), unlinked, with their current roles. Directory-bound mappings go with the directory.",
        "confirm": "Delete"
      }
    },
    "domains": {
      "new": "Claim domain",
      "delete": "Release domain",
      "empty": "No email domains claimed yet.",
      "columns": {
        "domain": "Domain",
        "system": "Health system",
        "actions": "Actions"
      },
      "toast": {
        "created": "{{domain}} claimed.",
        "createFailed": "Could not claim the domain.",
        "deleted": "Domain released.",
        "deleteFailed": "Could not release the domain."
      },
      "deleteConfirm": {
        "title": "Release {{domain}}?",
        "description": "Staff with this email domain will no longer route to SSO.",
        "confirm": "Release"
      },
      "add": {
        "title": "Claim email domain",
        "description": "One domain routes to exactly one health system.",
        "confirm": "Claim",
        "system": "Health system",
        "systemPlaceholder": "Select a health system",
        "domain": "Domain"
      }
    },
    "scim": {
      "hint": "Point the identity provider's SCIM client at {{url}} \u2014 one bearer token per health system, pasted as the secret.",
      "copyUrl": "Copy URL",
      "urlCopied": "Tenant URL copied.",
      "new": "New token",
      "empty": "No SCIM tokens yet.",
      "columns": {
        "label": "Label",
        "system": "Health system",
        "prefix": "Prefix",
        "status": "Status",
        "actions": "Actions"
      },
      "revoke": "Revoke token",
      "toast": {
        "mintFailed": "Could not mint the token.",
        "revoked": "Token revoked.",
        "revokeFailed": "Could not revoke the token."
      },
      "revokeConfirm": {
        "title": "Revoke {{label}}?",
        "description": "The token stops authenticating immediately. In-flight sync cycles fail on their next call.",
        "confirm": "Revoke"
      },
      "mint": {
        "title": "Mint SCIM token",
        "description": "One token provisions exactly one health system. The secret renders once.",
        "confirm": "Mint",
        "system": "Health system",
        "systemPlaceholder": "Select a health system",
        "label": "Label"
      },
      "secret": {
        "title": "Token minted",
        "body": "Copy this secret into the identity provider now \u2014 it never renders again.",
        "secret": "Secret",
        "copy": "Copy secret",
        "copied": "Secret copied.",
        "dismiss": "Done"
      }
    },
    "providerForm": {
      "back": "Back to single sign-on",
      "editTitle": "Edit identity provider",
      "newTitle": "New identity provider",
      "healthSystem": "Health system",
      "healthSystemPlaceholder": "Select a health system",
      "name": "Name",
      "enabled": "Enabled",
      "kind": "Protocol",
      "kindOidc": "OpenID Connect (OIDC)",
      "kindSaml": "SAML 2.0",
      "kindFlipHint": "Changing protocol clears the other protocol's settings on save.",
      "issuer": "Issuer URL",
      "issuerSamlHint": "The IdP entity ID — must exactly match the entity in the metadata below. URNs (e.g. ADFS) are fine.",
      "clientId": "Client ID",
      "clientSecret": "Client secret",
      "secretKeep": "A secret is stored. Leave blank to keep it.",
      "secretUnset": "No secret stored (public client).",
      "secretNewHint": "Blank means no secret (public client).",
      "secretClear": "Clear the stored secret",
      "groupClaim": "Group claim",
      "metadata": "IdP metadata XML",
      "metadataHint": "Paste the IdP metadata XML. It must parse and name the entity ID above.",
      "save": "Save",
      "saving": "Saving…",
      "test": "Test connection",
      "testing": "Testing…",
      "toast": {
        "updated": "Provider updated.",
        "created": "Provider created.",
        "failed": "Could not save the provider.",
        "testFailed": "Could not test the provider."
      }
    },
    "maps": {
      "title": "Group mappings",
      "subtitle": "IdP groups granted a role at next sign-in.",
      "new": "Add mapping",
      "empty": "No group mappings yet.",
      "columns": {
        "group": "Group",
        "role": "Role",
        "facility": "Facility",
        "actions": "Actions"
      },
      "systemWide": "All facilities",
      "delete": "Delete mapping",
      "toast": {
        "created": "Mapping added.",
        "createFailed": "Could not add the mapping.",
        "deleted": "Mapping deleted.",
        "deleteFailed": "Could not delete the mapping."
      },
      "add": {
        "title": "Add group mapping",
        "description": "Members of this IdP group receive the role at sign-in.",
        "confirm": "Add",
        "group": "IdP group",
        "role": "Role",
        "rolePlaceholder": "Select a role",
        "facility": "Facility (blank means all facilities)"
      },
      "deleteConfirm": {
        "title": "Delete mapping for {{group}}?",
        "description": "Existing grants stay until the next sign-in re-derives them.",
        "confirm": "Delete"
      }
    },
    "directoryForm": {
      "back": "Back to single sign-on",
      "editTitle": "Edit LDAP directory",
      "newTitle": "New LDAP directory",
      "healthSystem": "Health system",
      "healthSystemPlaceholder": "Select a health system",
      "name": "Name",
      "enabled": "Enabled",
      "host": "Host",
      "port": "Port",
      "portPlaceholder": "Default",
      "tlsMode": "TLS mode",
      "tlsVerify": "Verify TLS certificates",
      "caPem": "CA bundle (PEM)",
      "caSet": "A CA bundle is stored.",
      "caReplace": "Replace",
      "caEditHint": "Blank clears to system roots. Leave the toggle off to keep the stored bundle.",
      "caNewHint": "Blank means system roots. Paste the hospital root CA for private PKI.",
      "bindDn": "Bind DN",
      "bindPassword": "Bind password",
      "passwordKeep": "A password is stored. Leave blank to keep it.",
      "passwordUnset": "No password stored (anonymous search).",
      "passwordNewHint": "Blank with a bind DN refuses; blank without one means anonymous search.",
      "passwordClear": "Clear the stored password",
      "baseDn": "Base DN",
      "userFilter": "User filter",
      "groupAttribute": "Group attribute",
      "nameAttribute": "Name attribute",
      "save": "Save",
      "saving": "Saving…",
      "toast": {
        "updated": "Directory updated.",
        "created": "Directory created.",
        "failed": "Could not save the directory."
      }
    },
    "ldapMaps": {
      "title": "Group mappings",
      "subtitle": "Directory groups granted a role at next sign-in.",
      "new": "Add mapping",
      "empty": "No group mappings yet.",
      "columns": {
        "group": "Group",
        "role": "Role",
        "facility": "Facility",
        "actions": "Actions"
      },
      "systemWide": "All facilities",
      "delete": "Delete mapping",
      "toast": {
        "created": "Mapping added.",
        "createFailed": "Could not add the mapping.",
        "deleted": "Mapping deleted.",
        "deleteFailed": "Could not delete the mapping."
      },
      "add": {
        "title": "Add group mapping",
        "description": "Members of this directory group receive the role at sign-in.",
        "confirm": "Add",
        "group": "Directory group (CN)",
        "role": "Role",
        "rolePlaceholder": "Select a role",
        "facility": "Facility (blank means all facilities)"
      },
      "deleteConfirm": {
        "title": "Delete mapping for {{group}}?",
        "description": "Existing grants stay until the next sign-in re-derives them.",
        "confirm": "Delete"
      }
    }
  }
,
  "userGroups": {
    "title": "User Groups",
    "subtitle": "Health-system groups with materialized role grants.",
    "new": "New group",
    "edit": "Edit",
    "delete": "Delete",
    "empty": "No user groups yet.",
    "status": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "columns": {
      "name": "Name",
      "system": "Health system",
      "status": "Status",
      "members": "Members",
      "grants": "Grants",
      "actions": "Actions"
    },
    "toast": {
      "deleted": "Group deleted.",
      "deletedRetracted": "Group deleted; {{count}} grant(s) retracted.",
      "deleteFailed": "Could not delete the group."
    },
    "confirmDelete": {
      "title": "Delete this group?",
      "description": "Memberships and grants go with {{name}}. Grants no other group covers retract immediately."
    },
    "form": {
      "back": "Back to groups",
      "newTitle": "New user group",
      "editTitle": "Edit user group",
      "healthSystem": "Health system",
      "healthSystemPlaceholder": "Select a health system",
      "name": "Name",
      "namePlaceholder": "e.g. Night-shift nurses",
      "active": "Active",
      "activeHint": "Deactivating retracts every grant this group confers until reactivated.",
      "save": "Save",
      "saving": "Saving\u2026",
      "cancel": "Cancel",
      "toast": {
        "created": "Group created.",
        "createFailed": "Could not create the group.",
        "saved": "Group saved.",
        "saveFailed": "Could not save the group.",
        "loadFailed": "Could not load the group."
      }
    },
    "members": {
      "title": "Members",
      "subtitle": "The group\u2019s grants apply to every member.",
      "add": "Add member",
      "remove": "Remove",
      "empty": "No members yet.",
      "columns": {
        "username": "Username",
        "fullName": "Full name",
        "actions": "Actions"
      },
      "toast": {
        "added": "Member added.",
        "addFailed": "Could not add the member.",
        "removed": "Member removed.",
        "removeFailed": "Could not remove the member."
      },
      "addDialog": {
        "title": "Add member",
        "description": "The group\u2019s grants apply to the new member immediately.",
        "confirm": "Add",
        "user": "User",
        "userPlaceholder": "Select a user"
      },
      "deleteConfirm": {
        "title": "Remove {{name}}?",
        "description": "Grants no other group covers retract immediately."
      }
    },
    "grants": {
      "title": "Grants",
      "subtitle": "Roles this group confers on its members.",
      "add": "Add grant",
      "remove": "Remove",
      "empty": "No grants yet.",
      "systemWide": "System-wide",
      "columns": {
        "role": "Role",
        "facility": "Facility",
        "actions": "Actions"
      },
      "toast": {
        "added": "Grant added.",
        "addFailed": "Could not add the grant.",
        "removed": "Grant removed.",
        "removeFailed": "Could not remove the grant."
      },
      "addDialog": {
        "title": "Add grant",
        "description": "The grant fans out to every member immediately.",
        "confirm": "Add",
        "role": "Role",
        "rolePlaceholder": "Select a role",
        "facility": "Facility (optional)"
      },
      "deleteConfirm": {
        "title": "Remove the {{role}} grant?",
        "description": "Members lose it unless another grant still covers them."
      }
    }
  },
  "fileKey": {
      "title": "License key",
      "subtitle": "File-key licensing for this self-managed installation.",
      "refresh": "Refresh",
      "loadError": "Could not load license status.",
      "status": {
        "valid": "Valid",
        "evaluation": "Evaluation",
        "grace": "Grace period",
        "expired": "Expired",
        "invalid": "Invalid",
        "serving": "Serving requests.",
        "refused": "Refusing requests.",
        "reason": "Reason",
        "evalCountdown": "No license key installed. Evaluation ends in {{count}} days — install a key before then.",
        "evalCapUsage": "Evaluation patients: {{used}} of {{cap}} used. New registrations refuse past the cap \u2014 install a license key to continue.",
        "graceCountdown": "Service continues for {{count}} more hours while this is resolved. Install a valid key before the window closes."
      },
      "fields": {
        "customer": "Customer",
        "format": "Format",
        "purpose": "Purpose",
        "expires": "Expires",
        "maxUsers": "Max users",
        "derivation": "Host binding",
        "features": "Features"
      },
      "format": {
        "flostel": "FLOSTEL (JSON)",
        "vyna": "Legacy VYNA"
      },
      "derivation": {
        "strong": "Strong (hardware-anchored)",
        "weak": "Weak (machine-id only)"
      },
      "hosts": {
        "title": "Bound hosts",
        "subtitle": "Every host computer ID this key covers. HA installs carry one entry per host.",
        "floating": "Floating key — not bound to any host.",
        "covered": "Key covers {{count}} host(s).",
        "thisHost": "This host",
        "notCovered": "This host is NOT covered by the installed key. The key was issued for different host IDs."
      },
      "host": {
        "title": "This host",
        "subtitle": "Send this computer ID to the vendor to receive a bound key. HA installs collect one per host.",
        "copy": "Copy",
        "copied": "Copied",
        "copyFailed": "Copy failed.",
        "strength": "Binding strength",
        "dmi": "DMI product UUID",
        "present": "Present",
        "absent": "Unreadable",
        "machineId": "OS machine ID",
        "why": "Why two IDs?"
      },
      "request": {
        "title": "Request a key",
        "subtitle": "Generate the unsigned request file the vendor signs. This host is always included; add HA members below. Contact and notes go in the email summary only.",
        "customerLabel": "Customer",
        "customerPlaceholder": "e.g. Acme Hospital",
        "maxUsersLabel": "Max users",
        "maxUsersPlaceholder": "Blank = unlimited",
        "contactLabel": "Contact",
        "contactPlaceholder": "Name and email for the vendor",
        "notesLabel": "Notes",
        "notesPlaceholder": "Optional context for the vendor",
        "featuresLabel": "Licensed modules",
        "hostsLabel": "Extra HA hosts",
        "hostsPlaceholder": "One host fingerprint per line, from each member's license page",
        "hostsHint": "This host ({{fp}}) is always included.",
        "generate": "Generate request",
        "invalidMaxUsers": "Max users must be a whole number.",
        "failed": "Request generation failed.",
        "summaryTitle": "Email summary",
        "copySummary": "Copy summary",
        "copiedSummary": "Copied",
        "fileTitle": "Request file",
        "download": "Download request file"
      },
      "install": {
        "title": "Install a key",
        "subtitle": "Paste the JSON key from the vendor. It is verified before anything is written — invalid keys are refused, never stored.",
        "placeholder": "Paste the license key JSON here…",
        "action": "Install key",
        "success": "License key installed.",
        "failed": "Key install failed.",
        "haNote": "HA: repeat on every host, or mount one key file everywhere. Kubernetes Secret mounts are updated in the cluster, not here."
      }
    },
    "orgKey": {
      "title": "Organization license key",
      "subtitle": "Signed module license for health system {{id}}.",
      "back": "Health systems",
      "refresh": "Refresh",
      "loadError": "Could not load organization key status.",
      "status": {
        "valid": "Valid",
        "missing": "Not installed",
        "broken": "Invalid",
        "missingHint": "No key installed. Premium modules (billing, analytics) stay off; clinical care is unaffected.",
        "reason": "Reason"
      },
      "fields": {
        "customer": "Customer",
        "expires": "Expires",
        "maxUsers": "Max users",
        "purpose": "Purpose",
        "installedAt": "Installed",
        "features": "Licensed modules"
      },
      "install": {
        "title": "Install a key",
        "subtitle": "Paste the JSON key from the vendor. It is verified before anything is written — invalid keys are refused, never stored.",
        "placeholder": "Paste the license key JSON here…",
        "action": "Install key",
        "success": "Organization key installed.",
        "failed": "Key install failed.",
        "floatingNote": "Organization keys must be floating — machine binding is meaningless for SaaS."
      },
      "delete": {
        "title": "Remove the key",
        "subtitle": "Premium modules turn off for every facility in this organization. Clinical care is unaffected.",
        "action": "Remove key",
        "confirm": "Yes, remove it",
        "cancel": "Cancel",
        "success": "Organization key removed.",
        "failed": "Key removal failed."
      }
    }
}
